import { clsx as e } from "clsx";
import { twMerge as t } from "tailwind-merge";
import { createTwc as n } from "react-twc";
import { Avatar as r, Tabs as i } from "radix-ui";
import * as a from "react";
import o, { Children as s, cloneElement as c, createContext as l, forwardRef as u, isValidElement as d, useContext as f, useEffect as p, useEffectEvent as m, useId as h, useLayoutEffect as g, useMemo as _, useRef as v, useState as y } from "react";
import { Fragment as b, jsx as x, jsxs as S } from "react/jsx-runtime";
import { cva as C } from "class-variance-authority";
import { enUS as ee } from "date-fns/locale/en-US";
import { pl as te } from "date-fns/locale/pl";
import { Icon as w } from "icons";
import { DayPicker as ne } from "react-day-picker";
import { assert as re, convertFromUTCDate as ie, convertToUTCDate as T, isDateWithoutTime as E, useTime as D } from "utils";
import { Slot as O } from "@radix-ui/react-slot";
import ae from "embla-carousel-react";
import * as oe from "@radix-ui/react-collapsible";
import { Command as k, defaultFilter as se } from "cmdk";
import * as A from "@radix-ui/react-dialog";
import * as j from "@radix-ui/react-context-menu";
import * as M from "@radix-ui/react-dropdown-menu";
import { Controller as ce, FormProvider as le, useFormContext as ue } from "react-hook-form";
import * as de from "@radix-ui/react-label";
import * as N from "@radix-ui/react-popover";
import * as P from "@radix-ui/react-radio-group";
import * as F from "@radix-ui/react-scroll-area";
import * as I from "@radix-ui/react-select";
import * as fe from "@radix-ui/react-slider";
import * as pe from "@radix-ui/react-separator";
import * as L from "@radix-ui/react-switch";
import * as R from "@radix-ui/react-toast";
import * as z from "@radix-ui/react-tooltip";
import * as B from "@radix-ui/react-alert-dialog";
import * as V from "recharts";
import { Bar as me, BarChart as H, CartesianGrid as he, Cell as ge, ComposedChart as U, Customized as _e, Legend as ve, Line as ye, LineChart as be, ReferenceArea as xe, ReferenceLine as Se, XAxis as Ce, YAxis as we } from "recharts";
import * as W from "@radix-ui/react-accordion";
import { Drawer as G } from "vaul";
import { Combobox as K } from "@base-ui/react/combobox";
import { NumberField as Te } from "@base-ui/react/number-field";
import * as Ee from "@radix-ui/react-checkbox";
import { addMinutes as De, endOfDay as Oe, isAfter as ke, isBefore as Ae, set as je } from "date-fns";
import { flushSync as Me } from "react-dom";
import { useDateFieldState as Ne, useDatePickerState as Pe } from "react-stately";
import { CalendarDateTime as Fe, Time as Ie, createCalendar as Le } from "@internationalized/date";
import { useDateField as Re, useDateSegment as ze, useLocale as Be } from "react-aria";
import Ve from "react-input-autosize";
//#region src/lib/utils/cn.ts
function q(...n) {
	return t(e(n));
}
//#endregion
//#region src/lib/utils/twx.ts
var He = n({ compose: q });
//#endregion
//#region src/components/ui/avatar.tsx
function Ue({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ x(r.Root, {
		"data-slot": "avatar",
		"data-size": t,
		className: q("after:border-border group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten", e),
		...n
	});
}
function We({ className: e, ...t }) {
	return /* @__PURE__ */ x(r.Image, {
		"data-slot": "avatar-image",
		className: q("aspect-square size-full rounded-full object-cover", e),
		...t
	});
}
function Ge({ className: e, ...t }) {
	return /* @__PURE__ */ x(r.Fallback, {
		"data-slot": "avatar-fallback",
		className: q("bg-muted text-muted-foreground flex size-full items-center justify-center rounded-full text-sm group-data-[size=sm]/avatar:text-xs", e),
		...t
	});
}
function Ke({ className: e, ...t }) {
	return /* @__PURE__ */ x("span", {
		"data-slot": "avatar-badge",
		className: q("bg-primary text-primary-foreground ring-background absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-blend-color ring-2 select-none", "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden", "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2", "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2", e),
		...t
	});
}
function qe({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "avatar-group",
		className: q("*:data-[slot=avatar]:ring-background group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2", e),
		...t
	});
}
function Je({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "avatar-group-count",
		className: q("bg-muted text-muted-foreground ring-background relative flex size-8 shrink-0 items-center justify-center rounded-full text-sm ring-2 group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3", e),
		...t
	});
}
//#endregion
//#region src/components/ui/badge.tsx
var Ye = C("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
	variants: { variant: {
		default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
		secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
		destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
		outline: "text-foreground"
	} },
	defaultVariants: { variant: "default" }
}), Xe = a.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ x("div", {
	ref: r,
	className: q(Ye({ variant: t }), e),
	...n
})), Ze = C("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/90",
			destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
			outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-9 px-4 py-2 has-[>svg]:px-3",
			sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
			lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
			icon: "size-9",
			"icon-xs": "size-6",
			"icon-sm": "size-8",
			"icon-lg": "size-10"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function J({ className: e, variant: t, size: n, asChild: r = !1, ...i }) {
	return /* @__PURE__ */ x(r ? O : "button", {
		"data-slot": "button",
		className: q(Ze({
			variant: t,
			size: n,
			className: e
		})),
		...i
	});
}
//#endregion
//#region src/components/ui/calendar.tsx
var Qe = {
	en: ee,
	pl: te
};
function $e({ className: e, classNames: t, showOutsideDays: n = !0, ...r }) {
	return /* @__PURE__ */ x(ne, {
		locale: Qe[D().locale],
		weekStartsOn: 1,
		showOutsideDays: n,
		className: q("p-3", e),
		classNames: {
			months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
			month: "space-y-4",
			caption: "flex justify-center pt-1 relative items-center",
			caption_label: "text-sm font-medium",
			nav: "space-x-1 flex items-center",
			nav_button: q(Ze({ variant: "outline" }), "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
			nav_button_previous: "absolute left-1",
			nav_button_next: "absolute right-1",
			table: "w-full border-collapse space-y-1",
			head_row: "flex",
			head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
			row: "flex w-full mt-2",
			cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
			day: q(Ze({ variant: "ghost" }), "h-9 w-9 p-0 font-normal aria-selected:opacity-100"),
			day_range_end: "day-range-end",
			day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
			day_today: "bg-accent text-accent-foreground",
			day_outside: "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
			day_disabled: "text-muted-foreground opacity-50",
			day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
			day_hidden: "invisible",
			...t
		},
		components: {
			IconLeft: ({ className: e, ...t }) => /* @__PURE__ */ x(w, {
				name: "tabler-chevron-left",
				className: q("h-4 w-4", e),
				...t
			}),
			IconRight: ({ className: e, ...t }) => /* @__PURE__ */ x(w, {
				name: "tabler-chevron-right",
				className: q("h-4 w-4", e),
				...t
			})
		},
		...r
	});
}
$e.displayName = "Calendar";
//#endregion
//#region src/components/ui/carousel.tsx
var et = a.createContext(null);
function tt() {
	let e = a.useContext(et);
	if (!e) throw Error("useCarousel must be used within a <Carousel />");
	return e;
}
function nt(e) {
	let [t, n] = ae({
		...e.opts,
		axis: e.orientation === "vertical" ? "y" : "x"
	}, e.plugins), [r, i] = a.useState(!1), [o, s] = a.useState(!1), c = e.orientation ?? "horizontal";
	function l(e) {
		e && (i(e.canScrollPrev()), s(e.canScrollNext()));
	}
	function u() {
		n?.scrollPrev();
	}
	function d() {
		n?.scrollNext();
	}
	function f(e) {
		e.key === "ArrowLeft" && (e.preventDefault(), u()), e.key === "ArrowRight" && (e.preventDefault(), d());
	}
	return a.useEffect(() => {
		!n || !e.setApi || e.setApi(n);
	}, [n, e.setApi]), a.useEffect(() => {
		if (n) return l(n), n.on("reInit", l), n.on("select", l), () => {
			n.off("reInit", l), n.off("select", l);
		};
	}, [n]), /* @__PURE__ */ x(et.Provider, {
		value: {
			carouselRef: t,
			api: n,
			opts: e.opts,
			orientation: c,
			scrollPrev: u,
			scrollNext: d,
			canScrollPrev: r,
			canScrollNext: o
		},
		children: /* @__PURE__ */ x("div", {
			"data-slot": "carousel",
			className: q("relative", e.className),
			onKeyDownCapture: f,
			role: "region",
			"aria-roledescription": "carousel",
			children: e.children
		})
	});
}
function rt(e) {
	let t = tt();
	return /* @__PURE__ */ x("div", {
		ref: t.carouselRef,
		"data-slot": "carousel-content",
		className: "overflow-hidden",
		children: /* @__PURE__ */ x("div", {
			className: q("flex", t.orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col", e.className),
			children: e.children
		})
	});
}
function it(e) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "carousel-item",
		role: "group",
		"aria-roledescription": "slide",
		className: q("min-w-0 shrink-0 grow-0 basis-full", tt().orientation === "horizontal" ? "pl-4" : "pt-4", e.className),
		children: e.children
	});
}
function at(e) {
	let t = tt();
	return /* @__PURE__ */ S(J, {
		"data-slot": "carousel-previous",
		variant: e.variant ?? "outline",
		size: e.size ?? "icon",
		className: q("absolute size-8 rounded-full", t.orientation === "horizontal" ? "top-1/2 -left-12 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90", e.className),
		disabled: !t.canScrollPrev,
		onClick: t.scrollPrev,
		type: "button",
		children: [/* @__PURE__ */ x(w, { name: "tabler-chevron-left" }), /* @__PURE__ */ x("span", {
			className: "sr-only",
			children: "Previous slide"
		})]
	});
}
function ot(e) {
	let t = tt();
	return /* @__PURE__ */ S(J, {
		"data-slot": "carousel-next",
		variant: e.variant ?? "outline",
		size: e.size ?? "icon",
		className: q("absolute size-8 rounded-full", t.orientation === "horizontal" ? "top-1/2 -right-12 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90", e.className),
		disabled: !t.canScrollNext,
		onClick: t.scrollNext,
		type: "button",
		children: [/* @__PURE__ */ x(w, { name: "tabler-chevron-right" }), /* @__PURE__ */ x("span", {
			className: "sr-only",
			children: "Next slide"
		})]
	});
}
//#endregion
//#region src/components/ui/card.tsx
var st = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	ref: n,
	className: q("rounded-lg border bg-card text-card-foreground shadow-sm", e),
	...t
}));
st.displayName = "Card";
var ct = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	ref: n,
	className: q("flex flex-col space-y-1.5 p-6", e),
	...t
}));
ct.displayName = "CardHeader";
var lt = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	ref: n,
	className: q("text-2xl font-semibold leading-none tracking-tight", e),
	...t
}));
lt.displayName = "CardTitle";
var ut = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	ref: n,
	className: q("text-sm text-muted-foreground", e),
	...t
}));
ut.displayName = "CardDescription";
var dt = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	ref: n,
	className: q("p-6 pt-0", e),
	...t
}));
dt.displayName = "CardContent";
var ft = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	ref: n,
	className: q("flex items-center p-6 pt-0", e),
	...t
}));
ft.displayName = "CardFooter";
//#endregion
//#region src/components/ui/collapsible.tsx
var pt = oe.Root, mt = oe.CollapsibleTrigger, ht = oe.CollapsibleContent;
//#endregion
//#region src/components/ui/dialog.tsx
function gt({ ...e }) {
	return /* @__PURE__ */ x(A.Root, {
		"data-slot": "dialog",
		...e
	});
}
function _t({ ...e }) {
	return /* @__PURE__ */ x(A.Trigger, {
		"data-slot": "dialog-trigger",
		...e
	});
}
function vt({ ...e }) {
	return /* @__PURE__ */ x(A.Portal, {
		"data-slot": "dialog-portal",
		...e
	});
}
function yt({ ...e }) {
	return /* @__PURE__ */ x(A.Close, {
		"data-slot": "dialog-close",
		...e
	});
}
function bt({ className: e, ...t }) {
	return /* @__PURE__ */ x(A.Overlay, {
		"data-slot": "dialog-overlay",
		className: q("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", e),
		...t
	});
}
function xt({ className: e, children: t, showCloseButton: n = !0, onOverlayClick: r, onEscapeKeyDown: i, ...a }) {
	return /* @__PURE__ */ S(vt, {
		"data-slot": "dialog-portal",
		children: [/* @__PURE__ */ x(bt, { onClick: r }), /* @__PURE__ */ S(A.Content, {
			"data-slot": "dialog-content",
			className: q("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg", e),
			onEscapeKeyDown: (e) => {
				e.target instanceof Element && e.target.closest("[data-slot=\"dialog-content\"]")?.querySelector("[data-slot=\"combobox-content\"][data-open]") && e.preventDefault(), i?.(e);
			},
			...a,
			children: [t, n && /* @__PURE__ */ S(A.Close, {
				"data-slot": "dialog-close",
				className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
				children: [/* @__PURE__ */ x(w, { name: "tabler-x" }), /* @__PURE__ */ x("span", {
					className: "sr-only",
					children: "Close"
				})]
			})]
		})]
	});
}
function St({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "dialog-header",
		className: q("flex flex-col gap-2 text-center sm:text-left", e),
		...t
	});
}
function Ct({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "dialog-footer",
		className: q("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
		...t
	});
}
function wt({ className: e, ...t }) {
	return /* @__PURE__ */ x(A.Title, {
		"data-slot": "dialog-title",
		className: q("text-lg leading-none font-semibold", e),
		...t
	});
}
function Tt({ className: e, ...t }) {
	return /* @__PURE__ */ x(A.Description, {
		"data-slot": "dialog-description",
		className: q("text-muted-foreground text-sm", e),
		...t
	});
}
//#endregion
//#region src/components/ui/command.tsx
var Et = se, Dt = a.forwardRef(({ className: e, onItemHighlighted: t, ...n }, r) => {
	let i = a.useRef(null), o = a.useRef(t);
	return a.useEffect(() => {
		o.current = t;
	}), a.useEffect(() => {
		if (!i.current) return;
		let e = new MutationObserver(() => {
			let e = i.current?.querySelector("[cmdk-item][data-selected=\"true\"]");
			if (e) {
				let t = e.getAttribute("data-value");
				o.current?.(t);
			} else o.current?.(null);
		});
		return e.observe(i.current, {
			attributes: !0,
			attributeFilter: ["data-selected"],
			subtree: !0
		}), () => e.disconnect();
	}, []), /* @__PURE__ */ x(k, {
		ref: a.useCallback((e) => {
			typeof r == "function" ? r(e) : r && (r.current = e), i.current = e;
		}, [r]),
		className: q("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", e),
		...n
	});
});
Dt.displayName = k.displayName;
var Ot = ({ children: e, ...t }) => /* @__PURE__ */ x(gt, {
	...t,
	children: /* @__PURE__ */ x(xt, {
		className: "overflow-hidden p-0 shadow-lg",
		children: /* @__PURE__ */ x(Dt, {
			className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
			children: e
		})
	})
}), kt = a.forwardRef(({ className: e, left: t, right: n, ...r }, i) => /* @__PURE__ */ S("div", {
	className: "flex items-center border-b px-3",
	"cmdk-input-wrapper": "",
	children: [
		t ?? /* @__PURE__ */ x(w, {
			name: "tabler-search",
			className: "mr-2 h-4 w-4 shrink-0 opacity-50"
		}),
		/* @__PURE__ */ x(k.Input, {
			ref: i,
			className: q("flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", e),
			...r
		}),
		n && /* @__PURE__ */ x("div", {
			className: "ml-2",
			children: n
		})
	]
}));
kt.displayName = k.Input.displayName;
var At = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(k.List, {
	ref: n,
	className: q("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
	...t
}));
At.displayName = k.List.displayName;
var jt = a.forwardRef((e, t) => /* @__PURE__ */ x(k.Empty, {
	ref: t,
	className: "py-6 text-center text-sm",
	...e
}));
jt.displayName = k.Empty.displayName;
var Y = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(k.Group, {
	ref: n,
	className: q("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground", e),
	...t
}));
Y.displayName = k.Group.displayName;
var Mt = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(k.Separator, {
	ref: n,
	className: q("-mx-1 h-px bg-border", e),
	...t
}));
Mt.displayName = k.Separator.displayName;
var X = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(k.Item, {
	ref: n,
	className: q("relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", e),
	...t
}));
X.displayName = k.Item.displayName;
var Nt = ({ className: e, ...t }) => /* @__PURE__ */ x("span", {
	className: q("ml-auto text-xs tracking-widest text-muted-foreground", e),
	...t
});
Nt.displayName = "CommandShortcut";
//#endregion
//#region src/components/ui/context-menu.tsx
var Pt = j.Root, Ft = j.Trigger, It = j.Group, Lt = j.Portal, Rt = j.Sub, zt = j.RadioGroup, Bt = a.forwardRef(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ S(j.SubTrigger, {
	ref: i,
	className: q("flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground", t && "pl-8", e),
	...r,
	children: [n, /* @__PURE__ */ x(w, {
		name: "tabler-chevron-right",
		className: "ml-auto h-4 w-4"
	})]
}));
Bt.displayName = j.SubTrigger.displayName;
var Vt = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(j.SubContent, {
	ref: n,
	className: q("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", e),
	...t
}));
Vt.displayName = j.SubContent.displayName;
var Ht = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(j.Portal, { children: /* @__PURE__ */ x(j.Content, {
	ref: n,
	className: q("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md animate-in fade-in-80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", e),
	...t
}) }));
Ht.displayName = j.Content.displayName;
var Ut = a.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ x(j.Item, {
	ref: r,
	className: q("relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", t && "pl-8", e),
	...n
}));
Ut.displayName = j.Item.displayName;
var Wt = a.forwardRef(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ S(j.CheckboxItem, {
	ref: i,
	className: q("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	checked: n,
	...r,
	children: [/* @__PURE__ */ x("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ x(j.ItemIndicator, { children: /* @__PURE__ */ x(w, {
			name: "tabler-check",
			className: "h-4 w-4"
		}) })
	}), t]
}));
Wt.displayName = j.CheckboxItem.displayName;
var Gt = a.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ S(j.RadioItem, {
	ref: r,
	className: q("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	...n,
	children: [/* @__PURE__ */ x("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ x(j.ItemIndicator, { children: /* @__PURE__ */ x(w, {
			name: "tabler-circle",
			className: "h-2 w-2 fill-current"
		}) })
	}), t]
}));
Gt.displayName = j.RadioItem.displayName;
var Kt = a.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ x(j.Label, {
	ref: r,
	className: q("px-2 py-1.5 text-sm font-semibold text-foreground", t && "pl-8", e),
	...n
}));
Kt.displayName = j.Label.displayName;
var qt = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(j.Separator, {
	ref: n,
	className: q("-mx-1 my-1 h-px bg-border", e),
	...t
}));
qt.displayName = j.Separator.displayName;
var Jt = ({ className: e, ...t }) => /* @__PURE__ */ x("span", {
	className: q("ml-auto text-xs tracking-widest text-muted-foreground", e),
	...t
});
Jt.displayName = "ContextMenuShortcut";
//#endregion
//#region src/components/ui/dropdown-menu.tsx
var Yt = M.Root, Xt = M.Trigger, Zt = M.Group, Qt = M.Portal, $t = M.Sub, en = M.RadioGroup, tn = a.forwardRef(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ S(M.SubTrigger, {
	ref: i,
	className: q("flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", t && "pl-8", e),
	...r,
	children: [n, /* @__PURE__ */ x(w, {
		name: "tabler-chevron-right",
		className: "ml-auto"
	})]
}));
tn.displayName = M.SubTrigger.displayName;
var nn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(M.SubContent, {
	ref: n,
	className: q("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", e),
	...t
}));
nn.displayName = M.SubContent.displayName;
var rn = a.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ x(M.Portal, { children: /* @__PURE__ */ x(M.Content, {
	ref: r,
	sideOffset: t,
	className: q("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", e),
	...n
}) }));
rn.displayName = M.Content.displayName;
var an = a.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ x(M.Item, {
	ref: r,
	className: q("relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", t && "pl-8", e),
	...n
}));
an.displayName = M.Item.displayName;
var on = a.forwardRef(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ S(M.CheckboxItem, {
	ref: i,
	className: q("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	checked: n,
	...r,
	children: [/* @__PURE__ */ x("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ x(M.ItemIndicator, { children: /* @__PURE__ */ x(w, {
			name: "tabler-check",
			className: "h-4 w-4"
		}) })
	}), t]
}));
on.displayName = M.CheckboxItem.displayName;
var sn = a.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ S(M.RadioItem, {
	ref: r,
	className: q("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", e),
	...n,
	children: [/* @__PURE__ */ x("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ x(M.ItemIndicator, { children: /* @__PURE__ */ x(w, {
			name: "tabler-circle",
			className: "h-2 w-2 fill-current"
		}) })
	}), t]
}));
sn.displayName = M.RadioItem.displayName;
var cn = a.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ x(M.Label, {
	ref: r,
	className: q("px-2 py-1.5 text-sm font-semibold", t && "pl-8", e),
	...n
}));
cn.displayName = M.Label.displayName;
var ln = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(M.Separator, {
	ref: n,
	className: q("-mx-1 my-1 h-px bg-muted", e),
	...t
}));
ln.displayName = M.Separator.displayName;
var un = ({ className: e, ...t }) => /* @__PURE__ */ x("span", {
	className: q("ml-auto text-xs tracking-widest opacity-60", e),
	...t
});
un.displayName = "DropdownMenuShortcut";
//#endregion
//#region src/components/ui/label.tsx
var dn = C("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), fn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(de.Root, {
	ref: n,
	className: q(dn(), e),
	...t
}));
fn.displayName = de.Root.displayName;
//#endregion
//#region src/components/ui/form.tsx
var pn = le, mn = a.createContext({}), hn = ({ ...e }) => /* @__PURE__ */ x(mn.Provider, {
	value: {
		name: e.name,
		required: e.required
	},
	children: /* @__PURE__ */ x(ce, { ...e })
}), gn = () => {
	let e = a.useContext(mn), t = a.useContext(_n), { getFieldState: n, formState: r } = ue(), i = n(e.name, r);
	if (!e) throw Error("useFormField should be used within <FormField>");
	let { id: o } = t;
	return {
		id: o,
		name: e.name,
		formItemId: `${o}-form-item`,
		formDescriptionId: `${o}-form-item-description`,
		formMessageId: `${o}-form-item-message`,
		required: e.required,
		...i
	};
}, _n = a.createContext({}), vn = a.forwardRef(({ className: e, ...t }, n) => {
	let r = a.useId();
	return /* @__PURE__ */ x(_n.Provider, {
		value: { id: r },
		children: /* @__PURE__ */ x("div", {
			ref: n,
			className: q("space-y-2", e),
			...t
		})
	});
});
vn.displayName = "FormItem";
var yn = a.forwardRef(({ className: e, required: t, ...n }, r) => {
	let { error: i, formItemId: a, required: o } = gn(), s = t ?? o, c = /* @__PURE__ */ x(fn, {
		ref: r,
		className: q(i && "text-destructive", "leading-normal", e),
		htmlFor: a,
		...n
	});
	return s ? /* @__PURE__ */ S("div", {
		className: "flex gap-1 items-center",
		children: [c, /* @__PURE__ */ x(w, {
			name: "tabler-asterisk-simple",
			className: "text-red-500",
			size: 10,
			"aria-label": "required"
		})]
	}) : c;
});
yn.displayName = "FormLabel";
var bn = a.forwardRef(({ ...e }, t) => {
	let { error: n, formItemId: r, formDescriptionId: i, formMessageId: a } = gn();
	return /* @__PURE__ */ x(O, {
		ref: t,
		id: r,
		"aria-describedby": n ? `${i} ${a}` : `${i}`,
		"aria-invalid": !!n,
		...e
	});
});
bn.displayName = "FormControl";
var xn = a.forwardRef(({ className: e, ...t }, n) => {
	let { formDescriptionId: r } = gn();
	return /* @__PURE__ */ x("p", {
		ref: n,
		id: r,
		className: q("text-sm text-muted-foreground", e),
		...t
	});
});
xn.displayName = "FormDescription";
var Sn = a.forwardRef(({ className: e, children: t, ...n }, r) => {
	let { error: i, formMessageId: a } = gn(), o = i ? String(i?.message) : t;
	return o ? /* @__PURE__ */ x("p", {
		ref: r,
		id: a,
		className: q("text-sm font-medium text-destructive", e),
		...n,
		children: o
	}) : null;
});
Sn.displayName = "FormMessage";
//#endregion
//#region src/components/ui/popover.tsx
function Z({ ...e }) {
	return /* @__PURE__ */ x(N.Root, {
		"data-slot": "popover",
		...e
	});
}
function Cn({ ...e }) {
	return /* @__PURE__ */ x(N.Trigger, {
		"data-slot": "popover-trigger",
		...e
	});
}
var wn = N.PopoverClose;
function Q({ className: e, align: t = "center", sideOffset: n = 4, ...r }) {
	return /* @__PURE__ */ x(N.Portal, { children: /* @__PURE__ */ x(N.Content, {
		"data-slot": "popover-content",
		align: t,
		sideOffset: n,
		className: q("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden", e),
		...r
	}) });
}
function Tn({ ...e }) {
	return /* @__PURE__ */ x(N.Anchor, {
		"data-slot": "popover-anchor",
		...e
	});
}
//#endregion
//#region src/components/ui/radio-group.tsx
function En({ className: e, ...t }) {
	return /* @__PURE__ */ x(P.Root, {
		"data-slot": "radio-group",
		className: q("grid w-full gap-2", e),
		...t
	});
}
function Dn({ className: e, ...t }) {
	return /* @__PURE__ */ x(P.Item, {
		"data-slot": "radio-group-item",
		className: q("group/radio-group-item peer relative flex aspect-square size-4 shrink-0 rounded-full border border-input outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary", e),
		...t,
		children: /* @__PURE__ */ x(P.Indicator, {
			"data-slot": "radio-group-indicator",
			className: "flex size-4 items-center justify-center",
			children: /* @__PURE__ */ x("span", { className: "absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-foreground" })
		})
	});
}
//#endregion
//#region src/components/ui/scroll-area.tsx
var On = a.forwardRef(({ className: e, children: t, scrollRestorationId: n, ...r }, i) => /* @__PURE__ */ S(F.Root, {
	className: q("relative overflow-hidden", e),
	...r,
	children: [
		/* @__PURE__ */ x(F.Viewport, {
			ref: i,
			"data-scroll-restoration-id": n,
			className: "h-full w-full rounded-[inherit]",
			children: t
		}),
		/* @__PURE__ */ x(kn, {}),
		/* @__PURE__ */ x(F.Corner, {})
	]
}));
On.displayName = F.Root.displayName;
var kn = a.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ x(F.ScrollAreaScrollbar, {
	ref: r,
	orientation: t,
	className: q("flex touch-none select-none transition-colors", t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]", t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]", e),
	...n,
	children: /* @__PURE__ */ x(F.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })
}));
kn.displayName = F.ScrollAreaScrollbar.displayName;
//#endregion
//#region src/components/ui/select.tsx
function An({ ...e }) {
	return /* @__PURE__ */ x(I.Root, {
		"data-slot": "select",
		...e
	});
}
function jn({ ...e }) {
	return /* @__PURE__ */ x(I.Group, {
		"data-slot": "select-group",
		...e
	});
}
function Mn({ ...e }) {
	return /* @__PURE__ */ x(I.Value, {
		"data-slot": "select-value",
		...e
	});
}
function Nn({ className: e, size: t = "default", children: n, ...r }) {
	return /* @__PURE__ */ S(I.Trigger, {
		"data-slot": "select-trigger",
		"data-size": t,
		className: q("border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...r,
		children: [n, /* @__PURE__ */ x(I.Icon, {
			asChild: !0,
			children: /* @__PURE__ */ x(w, {
				name: "tabler-chevron-down",
				className: "size-4 opacity-50"
			})
		})]
	});
}
function Pn({ className: e, children: t, position: n = "popper", align: r = "center", ...i }) {
	return /* @__PURE__ */ x(I.Portal, { children: /* @__PURE__ */ S(I.Content, {
		"data-slot": "select-content",
		className: q("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md", n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", e),
		position: n,
		align: r,
		...i,
		children: [
			/* @__PURE__ */ x(Rn, {}),
			/* @__PURE__ */ x(I.Viewport, {
				className: q("p-1", n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
				children: t
			}),
			/* @__PURE__ */ x(zn, {})
		]
	}) });
}
function Fn({ className: e, ...t }) {
	return /* @__PURE__ */ x(I.Label, {
		"data-slot": "select-label",
		className: q("text-muted-foreground px-2 py-1.5 text-xs", e),
		...t
	});
}
function In({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ S(I.Item, {
		"data-slot": "select-item",
		className: q("focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", e),
		...n,
		children: [/* @__PURE__ */ x("span", {
			className: "absolute right-2 flex size-3.5 items-center justify-center",
			children: /* @__PURE__ */ x(I.ItemIndicator, { children: /* @__PURE__ */ x(w, {
				name: "tabler-check",
				className: "size-4"
			}) })
		}), /* @__PURE__ */ x(I.ItemText, { children: t })]
	});
}
function Ln({ className: e, ...t }) {
	return /* @__PURE__ */ x(I.Separator, {
		"data-slot": "select-separator",
		className: q("bg-border pointer-events-none -mx-1 my-1 h-px", e),
		...t
	});
}
function Rn({ className: e, ...t }) {
	return /* @__PURE__ */ x(I.ScrollUpButton, {
		"data-slot": "select-scroll-up-button",
		className: q("flex cursor-default items-center justify-center py-1", e),
		...t,
		children: /* @__PURE__ */ x(w, {
			name: "tabler-chevron-up",
			className: "size-4"
		})
	});
}
function zn({ className: e, ...t }) {
	return /* @__PURE__ */ x(I.ScrollDownButton, {
		"data-slot": "select-scroll-down-button",
		className: q("flex cursor-default items-center justify-center py-1", e),
		...t,
		children: /* @__PURE__ */ x(w, {
			name: "tabler-chevron-down",
			className: "size-4"
		})
	});
}
//#endregion
//#region src/components/ui/slider.tsx
var Bn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ S(fe.Root, {
	ref: n,
	className: q("relative flex w-full touch-none select-none items-center", e),
	...t,
	children: [/* @__PURE__ */ x(fe.Track, {
		className: "relative h-2 w-full grow overflow-hidden rounded-full bg-secondary",
		children: /* @__PURE__ */ x(fe.Range, { className: "absolute h-full bg-primary" })
	}), /* @__PURE__ */ x(fe.Thumb, { className: "block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" })]
}));
Bn.displayName = fe.Root.displayName;
//#endregion
//#region src/components/ui/separator.tsx
var Vn = a.forwardRef(({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, i) => /* @__PURE__ */ x(pe.Root, {
	ref: i,
	decorative: n,
	orientation: t,
	className: q("shrink-0 bg-border", t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", e),
	...r
}));
Vn.displayName = pe.Root.displayName;
//#endregion
//#region src/components/ui/switch.tsx
var Hn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(L.Root, {
	className: q("peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", e),
	...t,
	ref: n,
	children: /* @__PURE__ */ x(L.Thumb, { className: q("pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0") })
}));
Hn.displayName = L.Root.displayName;
//#endregion
//#region src/components/ui/table.tsx
var Un = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	className: "relative w-full overflow-auto",
	children: /* @__PURE__ */ x("table", {
		ref: n,
		className: q("w-full caption-bottom text-sm", e),
		...t
	})
}));
Un.displayName = "Table";
var Wn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("thead", {
	ref: n,
	className: q("[&_tr]:border-b", e),
	...t
}));
Wn.displayName = "TableHeader";
var Gn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("tbody", {
	ref: n,
	className: q("[&_tr:last-child]:border-0", e),
	...t
}));
Gn.displayName = "TableBody";
var Kn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("tfoot", {
	ref: n,
	className: q("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", e),
	...t
}));
Kn.displayName = "TableFooter";
var qn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("tr", {
	ref: n,
	className: q("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", e),
	...t
}));
qn.displayName = "TableRow";
var Jn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("th", {
	ref: n,
	className: q("h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0", e),
	...t
}));
Jn.displayName = "TableHead";
var Yn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("td", {
	ref: n,
	className: q("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
	...t
}));
Yn.displayName = "TableCell";
var Xn = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("caption", {
	ref: n,
	className: q("mt-4 text-sm text-muted-foreground", e),
	...t
}));
Xn.displayName = "TableCaption";
//#endregion
//#region src/components/ui/tabs.tsx
function Zn(e) {
	let t = e.orientation ?? "horizontal";
	return /* @__PURE__ */ x(i.Root, {
		...e,
		"data-slot": "tabs",
		"data-orientation": t,
		orientation: t,
		className: q("group/tabs flex gap-2 data-[orientation=horizontal]:flex-col", e.className)
	});
}
var Qn = C("group/tabs-list inline-flex w-fit items-center justify-center rounded-lg p-[3px] text-muted-foreground group-data-[orientation=horizontal]/tabs:h-8 group-data-[orientation=vertical]/tabs:h-fit group-data-[orientation=vertical]/tabs:flex-col data-[variant=line]:rounded-none", {
	variants: { variant: {
		default: "bg-muted",
		line: "gap-1 bg-transparent"
	} },
	defaultVariants: { variant: "default" }
});
function $n(e) {
	let t = e.variant ?? "default", n = nr(e);
	return /* @__PURE__ */ x(i.List, {
		...n,
		"data-slot": "tabs-list",
		"data-variant": t,
		className: q(Qn({ variant: t }), e.className)
	});
}
function er(e) {
	return /* @__PURE__ */ x(i.Trigger, {
		...e,
		"data-slot": "tabs-trigger",
		className: q("relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-1.5 py-0.5 text-sm font-medium whitespace-nowrap text-foreground/60 transition-all group-data-[orientation=vertical]/tabs:w-full group-data-[orientation=vertical]/tabs:justify-start hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 has-data-[icon=inline-end]:pr-1 has-data-[icon=inline-start]:pl-1 dark:text-muted-foreground dark:hover:text-foreground group-data-[variant=default]/tabs-list:data-[state=active]:shadow-sm group-data-[variant=line]/tabs-list:data-[state=active]:shadow-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent dark:group-data-[variant=line]/tabs-list:data-[state=active]:border-transparent dark:group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent", "data-[state=active]:bg-background data-[state=active]:text-foreground dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 dark:data-[state=active]:text-foreground", "after:absolute after:bg-foreground after:opacity-0 after:transition-opacity group-data-[orientation=horizontal]/tabs:after:inset-x-0 group-data-[orientation=horizontal]/tabs:after:bottom-[-5px] group-data-[orientation=horizontal]/tabs:after:h-0.5 group-data-[orientation=vertical]/tabs:after:inset-y-0 group-data-[orientation=vertical]/tabs:after:-right-1 group-data-[orientation=vertical]/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-[state=active]:after:opacity-100", e.className)
	});
}
function tr(e) {
	return /* @__PURE__ */ x(i.Content, {
		...e,
		"data-slot": "tabs-content",
		className: q("flex-1 text-sm outline-none", e.className)
	});
}
function nr(e) {
	let t = { ...e };
	return delete t.variant, t;
}
//#endregion
//#region src/components/ui/textarea.tsx
var rr = "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";
function ir() {
	return rr;
}
function ar({ className: e, ...t }) {
	return /* @__PURE__ */ x("textarea", {
		"data-slot": "textarea",
		className: q(rr, e),
		...t
	});
}
//#endregion
//#region src/components/ui/toast.tsx
var or = R.Provider, sr = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(R.Viewport, {
	ref: n,
	className: q("fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]", e),
	...t
}));
sr.displayName = R.Viewport.displayName;
var cr = C("group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-(--radix-toast-swipe-end-x) data-[swipe=move]:translate-x-(--radix-toast-swipe-move-x) data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full", {
	variants: { variant: {
		default: "border bg-background text-foreground",
		destructive: "destructive group bg-[#FF5E1A] text-foreground",
		success: "border-[#28D57C] bg-[#28D57C] text-foreground",
		warn: "border-[#FFE81A] bg-[#FFE81A] text-foreground"
	} },
	defaultVariants: { variant: "default" }
}), lr = a.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ x(R.Root, {
	ref: r,
	className: q(cr({ variant: t }), e),
	...n
}));
lr.displayName = R.Root.displayName;
var ur = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(R.Action, {
	ref: n,
	className: q("inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive", e),
	...t
}));
ur.displayName = R.Action.displayName;
var dr = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(R.Close, {
	ref: n,
	className: q("absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600", e),
	"toast-close": "",
	...t,
	children: /* @__PURE__ */ x(w, {
		name: "tabler-x",
		className: "h-4 w-4"
	})
}));
dr.displayName = R.Close.displayName;
var fr = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(R.Title, {
	ref: n,
	className: q("text-sm font-semibold", e),
	...t
}));
fr.displayName = R.Title.displayName;
var pr = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(R.Description, {
	ref: n,
	className: q("text-sm opacity-90", e),
	...t
}));
pr.displayName = R.Description.displayName;
//#endregion
//#region src/hooks/use-toast.ts
var mr = 1, hr = 1e6, gr = 0;
function _r() {
	return gr = (gr + 1) % (2 ** 53 - 1), gr.toString();
}
var vr = /* @__PURE__ */ new Map(), yr = (e) => {
	if (vr.has(e)) return;
	let t = setTimeout(() => {
		vr.delete(e), Cr({
			type: "REMOVE_TOAST",
			toastId: e
		});
	}, hr);
	vr.set(e, t);
}, br = (e, t) => {
	switch (t.type) {
		case "ADD_TOAST": return {
			...e,
			toasts: [t.toast, ...e.toasts].slice(0, mr)
		};
		case "UPDATE_TOAST": return {
			...e,
			toasts: e.toasts.map((e) => e.id === t.toast.id ? {
				...e,
				...t.toast
			} : e)
		};
		case "DISMISS_TOAST": {
			let { toastId: n } = t;
			return n ? yr(n) : e.toasts.forEach((e) => {
				yr(e.id);
			}), {
				...e,
				toasts: e.toasts.map((e) => e.id === n || n === void 0 ? {
					...e,
					open: !1
				} : e)
			};
		}
		case "REMOVE_TOAST": return t.toastId === void 0 ? {
			...e,
			toasts: []
		} : {
			...e,
			toasts: e.toasts.filter((e) => e.id !== t.toastId)
		};
	}
}, xr = [], Sr = { toasts: [] };
function Cr(e) {
	Sr = br(Sr, e), xr.forEach((e) => {
		e(Sr);
	});
}
function wr({ ...e }) {
	let t = _r(), n = (e) => Cr({
		type: "UPDATE_TOAST",
		toast: {
			...e,
			id: t
		}
	}), r = () => Cr({
		type: "DISMISS_TOAST",
		toastId: t
	});
	return Cr({
		type: "ADD_TOAST",
		toast: {
			...e,
			id: t,
			open: !0,
			onOpenChange: (e) => {
				e || r();
			}
		}
	}), {
		id: t,
		dismiss: r,
		update: n
	};
}
function Tr() {
	let [e, t] = a.useState(Sr);
	return a.useEffect(() => (xr.push(t), () => {
		let e = xr.indexOf(t);
		e > -1 && xr.splice(e, 1);
	}), [e]), {
		...e,
		toast: wr,
		dismiss: (e) => Cr({
			type: "DISMISS_TOAST",
			toastId: e
		})
	};
}
//#endregion
//#region src/components/ui/toaster.tsx
function Er() {
	let { toasts: e } = Tr();
	return /* @__PURE__ */ S(or, { children: [e.map(function({ id: e, title: t, description: n, action: r, ...i }) {
		return /* @__PURE__ */ S(lr, {
			...i,
			children: [/* @__PURE__ */ S("div", {
				className: "grid justify-items-start gap-3",
				children: [/* @__PURE__ */ S("div", {
					className: "grid gap-1",
					children: [t && /* @__PURE__ */ x(fr, { children: t }), n && /* @__PURE__ */ x(pr, { children: n })]
				}), r]
			}), /* @__PURE__ */ x(dr, {})]
		}, e);
	}), /* @__PURE__ */ x(sr, {})] });
}
//#endregion
//#region src/components/ui/tooltip.tsx
function Dr({ delayDuration: e = 0, ...t }) {
	return /* @__PURE__ */ x(z.Provider, {
		"data-slot": "tooltip-provider",
		delayDuration: e,
		...t
	});
}
function Or({ delayDuration: e, ...t }) {
	return /* @__PURE__ */ x(Dr, {
		delayDuration: e,
		children: /* @__PURE__ */ x(z.Root, {
			"data-slot": "tooltip",
			...t
		})
	});
}
function kr({ ...e }) {
	return /* @__PURE__ */ x(z.Trigger, {
		"data-slot": "tooltip-trigger",
		...e
	});
}
function Ar({ className: e, sideOffset: t = 0, children: n, ...r }) {
	return /* @__PURE__ */ x(z.Portal, { children: /* @__PURE__ */ S(z.Content, {
		"data-slot": "tooltip-content",
		sideOffset: t,
		className: q("bg-foreground text-background animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-pretty", e),
		...r,
		children: [n, /* @__PURE__ */ x(z.Arrow, { className: "bg-foreground fill-foreground z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })]
	}) });
}
//#endregion
//#region src/components/ui/alert-dialog.tsx
function jr({ ...e }) {
	return /* @__PURE__ */ x(B.Root, {
		"data-slot": "alert-dialog",
		...e
	});
}
function Mr({ ...e }) {
	return /* @__PURE__ */ x(B.Trigger, {
		"data-slot": "alert-dialog-trigger",
		...e
	});
}
function Nr({ ...e }) {
	return /* @__PURE__ */ x(B.Portal, {
		"data-slot": "alert-dialog-portal",
		...e
	});
}
function Pr({ className: e, ...t }) {
	return /* @__PURE__ */ x(B.Overlay, {
		"data-slot": "alert-dialog-overlay",
		className: q("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", e),
		...t
	});
}
function Fr({ className: e, ...t }) {
	return /* @__PURE__ */ S(Nr, { children: [/* @__PURE__ */ x(Pr, {}), /* @__PURE__ */ x(B.Content, {
		"data-slot": "alert-dialog-content",
		className: q("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg", e),
		...t
	})] });
}
function Ir({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "alert-dialog-header",
		className: q("flex flex-col gap-2 text-center sm:text-left", e),
		...t
	});
}
function Lr({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "alert-dialog-footer",
		className: q("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
		...t
	});
}
function Rr({ className: e, ...t }) {
	return /* @__PURE__ */ x(B.Title, {
		"data-slot": "alert-dialog-title",
		className: q("text-lg font-semibold", e),
		...t
	});
}
function zr({ className: e, ...t }) {
	return /* @__PURE__ */ x(B.Description, {
		"data-slot": "alert-dialog-description",
		className: q("text-muted-foreground text-sm", e),
		...t
	});
}
function Br({ className: e, ...t }) {
	return /* @__PURE__ */ x(B.Action, {
		className: q(Ze(), e),
		...t
	});
}
function Vr({ className: e, ...t }) {
	return /* @__PURE__ */ x(B.Cancel, {
		className: q(Ze({ variant: "outline" }), e),
		...t
	});
}
//#endregion
//#region src/components/ui/alert.tsx
var Hr = C("relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground", {
	variants: { variant: {
		default: "bg-background text-foreground",
		destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
	} },
	defaultVariants: { variant: "default" }
}), Ur = a.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ x("div", {
	ref: r,
	role: "alert",
	className: q(Hr({ variant: t }), e),
	...n
}));
Ur.displayName = "Alert";
var Wr = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("h5", {
	ref: n,
	className: q("mb-1 font-medium leading-none tracking-tight", e),
	...t
}));
Wr.displayName = "AlertTitle";
var Gr = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x("div", {
	ref: n,
	className: q("text-sm [&_p]:leading-relaxed", e),
	...t
}));
Gr.displayName = "AlertDescription";
//#endregion
//#region src/components/ui/skeleton.tsx
function Kr({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		className: q("animate-pulse rounded-md bg-muted", e),
		...t
	});
}
//#endregion
//#region src/components/ui/chart.tsx
var qr = {
	light: "",
	dark: ".dark"
}, Jr = a.createContext(null);
function Yr() {
	let e = a.useContext(Jr);
	if (!e) throw Error("useChart must be used within a <ChartContainer />");
	return e;
}
var Xr = a.forwardRef(({ id: e, className: t, children: n, config: r, ...i }, o) => {
	let s = a.useId(), c = `chart-${e || s.replace(/:/g, "")}`;
	return /* @__PURE__ */ x(Jr.Provider, {
		value: { config: r },
		children: /* @__PURE__ */ S("div", {
			"data-chart": c,
			ref: o,
			className: q("flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none", t),
			...i,
			children: [/* @__PURE__ */ x(Zr, {
				id: c,
				config: r
			}), /* @__PURE__ */ x(V.ResponsiveContainer, { children: n })]
		})
	});
});
Xr.displayName = "Chart";
var Zr = ({ id: e, config: t }) => {
	let n = Object.entries(t).filter(([, e]) => e.theme || e.color);
	return n.length ? /* @__PURE__ */ x("style", { dangerouslySetInnerHTML: { __html: Object.entries(qr).map(([t, r]) => `
${r} [data-chart=${e}] {
${n.map(([e, n]) => {
		let r = n.theme?.[t] || n.color;
		return r ? `  --color-${e}: ${r};` : null;
	}).join("\n")}
}
`).join("\n") } }) : null;
}, Qr = V.Tooltip, $r = a.forwardRef(({ active: e, payload: t, className: n, indicator: r = "dot", hideLabel: i = !1, hideIndicator: o = !1, label: s, labelFormatter: c, labelClassName: l, formatter: u, color: d, nameKey: f, labelKey: p }, m) => {
	let { config: h } = Yr(), g = a.useMemo(() => {
		if (i || !t?.length) return null;
		let [e] = t, n = ni(h, e, `${p || e.dataKey || e.name || "value"}`), r = !p && typeof s == "string" ? h[s]?.label || s : n?.label;
		return c ? /* @__PURE__ */ x("div", {
			className: q("font-medium", l),
			children: c(r, t)
		}) : r ? /* @__PURE__ */ x("div", {
			className: q("font-medium", l),
			children: r
		}) : null;
	}, [
		s,
		c,
		t,
		i,
		l,
		h,
		p
	]);
	if (!e || !t?.length) return null;
	let _ = t.length === 1 && r !== "dot";
	return /* @__PURE__ */ S("div", {
		ref: m,
		className: q("grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl", n),
		children: [_ ? null : g, /* @__PURE__ */ x("div", {
			className: "grid gap-1.5",
			children: t.map((e, t) => {
				let n = ni(h, e, `${f || e.name || e.dataKey || "value"}`), i = d || e.payload.fill || e.color;
				return /* @__PURE__ */ x("div", {
					className: q("flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground", r === "dot" && "items-center"),
					children: u && e?.value !== void 0 && e.name ? u(e.value, e.name, e, t, e.payload) : /* @__PURE__ */ S(b, { children: [n?.icon ? /* @__PURE__ */ x(n.icon, {}) : !o && /* @__PURE__ */ x("div", {
						className: q("shrink-0 rounded-[2px] border-(--color-border) bg-(--color-bg)", {
							"h-2.5 w-2.5": r === "dot",
							"w-1": r === "line",
							"w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
							"my-0.5": _ && r === "dashed"
						}),
						style: {
							"--color-bg": i,
							"--color-border": i
						}
					}), /* @__PURE__ */ S("div", {
						className: q("flex flex-1 justify-between leading-none", _ ? "items-end" : "items-center"),
						children: [/* @__PURE__ */ S("div", {
							className: "grid gap-1.5",
							children: [_ ? g : null, /* @__PURE__ */ x("span", {
								className: "text-muted-foreground",
								children: n?.label || e.name
							})]
						}), e.value && /* @__PURE__ */ x("span", {
							className: "font-mono font-medium tabular-nums text-foreground",
							children: e.value.toLocaleString()
						})]
					})] })
				}, e.dataKey);
			})
		})]
	});
});
$r.displayName = "ChartTooltip";
var ei = V.Legend, ti = a.forwardRef(({ className: e, hideIcon: t = !1, payload: n, verticalAlign: r = "bottom", nameKey: i }, a) => {
	let { config: o } = Yr();
	return n?.length ? /* @__PURE__ */ x("div", {
		ref: a,
		className: q("flex items-center justify-center gap-4", r === "top" ? "pb-3" : "pt-3", e),
		children: n.map((e) => {
			let n = ni(o, e, `${i || e.dataKey || "value"}`);
			return /* @__PURE__ */ S("div", {
				className: q("flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"),
				children: [n?.icon && !t ? /* @__PURE__ */ x(n.icon, {}) : /* @__PURE__ */ x("div", {
					className: "h-2 w-2 shrink-0 rounded-[2px]",
					style: { backgroundColor: e.color }
				}), n?.label]
			}, e.value);
		})
	}) : null;
});
ti.displayName = "ChartLegend";
function ni(e, t, n) {
	if (typeof t != "object" || !t) return;
	let r = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0, i = n;
	return n in t && typeof t[n] == "string" ? i = t[n] : r && n in r && typeof r[n] == "string" && (i = r[n]), i in e ? e[i] : e[n];
}
//#endregion
//#region src/components/ui/sheet.tsx
function ri({ ...e }) {
	return /* @__PURE__ */ x(A.Root, {
		"data-slot": "sheet",
		...e
	});
}
function ii({ ...e }) {
	return /* @__PURE__ */ x(A.Trigger, {
		"data-slot": "sheet-trigger",
		...e
	});
}
function ai({ ...e }) {
	return /* @__PURE__ */ x(A.Close, {
		"data-slot": "sheet-close",
		...e
	});
}
function oi({ ...e }) {
	return /* @__PURE__ */ x(A.Portal, {
		"data-slot": "sheet-portal",
		...e
	});
}
function si({ className: e, ...t }) {
	return /* @__PURE__ */ x(A.Overlay, {
		"data-slot": "sheet-overlay",
		className: q("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", e),
		...t
	});
}
function ci({ className: e, children: t, side: n = "right", ...r }) {
	return /* @__PURE__ */ S(oi, { children: [/* @__PURE__ */ x(si, {}), /* @__PURE__ */ S(A.Content, {
		"data-slot": "sheet-content",
		className: q("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500", n === "right" && "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm", n === "left" && "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm", n === "top" && "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b", n === "bottom" && "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t", e),
		...r,
		children: [t, /* @__PURE__ */ S(A.Close, {
			className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none",
			children: [/* @__PURE__ */ x(w, {
				name: "tabler-x",
				className: "size-4"
			}), /* @__PURE__ */ x("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] });
}
function li({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sheet-header",
		className: q("flex flex-col gap-1.5 p-0", e),
		...t
	});
}
function ui({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sheet-footer",
		className: q("mt-auto flex flex-col gap-2 p-4", e),
		...t
	});
}
function di({ className: e, ...t }) {
	return /* @__PURE__ */ x(A.Title, {
		"data-slot": "sheet-title",
		className: q("text-foreground font-semibold", e),
		...t
	});
}
function fi({ className: e, ...t }) {
	return /* @__PURE__ */ x(A.Description, {
		"data-slot": "sheet-description",
		className: q("text-muted-foreground text-sm", e),
		...t
	});
}
//#endregion
//#region src/components/ui/accordion.tsx
var pi = W.Root, mi = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(W.Item, {
	ref: n,
	className: q("border-b", e),
	...t
}));
mi.displayName = "AccordionItem";
var hi = a.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ x(W.Header, {
	className: "flex",
	children: /* @__PURE__ */ S(W.Trigger, {
		ref: r,
		className: q("flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180", e),
		...n,
		children: [t, /* @__PURE__ */ x(w, {
			name: "tabler-chevron-down",
			className: "h-4 w-4 shrink-0 transition-transform duration-200"
		})]
	})
}));
hi.displayName = W.Trigger.displayName;
var gi = a.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ x(W.Content, {
	ref: r,
	className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
	...n,
	children: /* @__PURE__ */ x("div", {
		className: q("pb-4 pt-0", e),
		children: t
	})
}));
gi.displayName = W.Content.displayName;
//#endregion
//#region src/components/ui/breadcrumb.tsx
function _i({ ...e }) {
	return /* @__PURE__ */ x("nav", {
		"aria-label": "breadcrumb",
		"data-slot": "breadcrumb",
		...e
	});
}
function vi({ className: e, ...t }) {
	return /* @__PURE__ */ x("ol", {
		"data-slot": "breadcrumb-list",
		className: q("text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5", e),
		...t
	});
}
function yi({ className: e, ...t }) {
	return /* @__PURE__ */ x("li", {
		"data-slot": "breadcrumb-item",
		className: q("inline-flex items-center gap-1.5", e),
		...t
	});
}
function bi({ asChild: e, className: t, ...n }) {
	return /* @__PURE__ */ x(e ? O : "a", {
		"data-slot": "breadcrumb-link",
		className: q("hover:text-foreground transition-colors", t),
		...n
	});
}
function xi({ className: e, ...t }) {
	return /* @__PURE__ */ x("span", {
		"data-slot": "breadcrumb-page",
		role: "link",
		"aria-disabled": "true",
		"aria-current": "page",
		className: q("text-foreground font-normal", e),
		...t
	});
}
function Si({ children: e, className: t, ...n }) {
	return /* @__PURE__ */ x("li", {
		"data-slot": "breadcrumb-separator",
		role: "presentation",
		"aria-hidden": "true",
		className: q("[&>svg]:size-3.5", t),
		...n,
		children: e ?? /* @__PURE__ */ x(w, { name: "tabler-chevron-right" })
	});
}
function Ci({ className: e, ...t }) {
	return /* @__PURE__ */ S("span", {
		"data-slot": "breadcrumb-ellipsis",
		role: "presentation",
		"aria-hidden": "true",
		className: q("flex size-9 items-center justify-center", e),
		...t,
		children: [/* @__PURE__ */ x(w, {
			name: "tabler-dots",
			className: "size-4"
		}), /* @__PURE__ */ x("span", {
			className: "sr-only",
			children: "More"
		})]
	});
}
//#endregion
//#region src/components/ui/drawer.tsx
var wi = ({ shouldScaleBackground: e = !0, ...t }) => /* @__PURE__ */ x(G.Root, {
	shouldScaleBackground: e,
	...t
});
wi.displayName = "Drawer";
var Ti = G.Trigger, Ei = G.Portal, Di = G.Close, Oi = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(G.Overlay, {
	ref: n,
	className: q("fixed inset-0 z-50 bg-black/80", e),
	...t
}));
Oi.displayName = G.Overlay.displayName;
var ki = a.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ S(Ei, { children: [/* @__PURE__ */ x(Oi, {}), /* @__PURE__ */ S(G.Content, {
	ref: r,
	className: q("fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border bg-background", e),
	...n,
	children: [/* @__PURE__ */ x("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }), t]
})] }));
ki.displayName = "DrawerContent";
var Ai = ({ className: e, ...t }) => /* @__PURE__ */ x("div", {
	className: q("grid gap-1.5 p-4 text-center sm:text-left", e),
	...t
});
Ai.displayName = "DrawerHeader";
var ji = ({ className: e, ...t }) => /* @__PURE__ */ x("div", {
	className: q("mt-auto flex flex-col gap-2 p-4", e),
	...t
});
ji.displayName = "DrawerFooter";
var Mi = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(G.Title, {
	ref: n,
	className: q("text-lg font-semibold leading-none tracking-tight", e),
	...t
}));
Mi.displayName = G.Title.displayName;
var Ni = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(G.Description, {
	ref: n,
	className: q("text-sm text-muted-foreground", e),
	...t
}));
Ni.displayName = G.Description.displayName;
//#endregion
//#region src/hooks/use-mobile.tsx
var Pi = 768;
function Fi() {
	let [e, t] = a.useState(void 0);
	return a.useEffect(() => {
		let e = window.matchMedia(`(max-width: ${Pi - 1}px)`), n = () => {
			t(window.innerWidth < Pi);
		};
		return e.addEventListener("change", n), t(window.innerWidth < Pi), () => e.removeEventListener("change", n);
	}, []), !!e;
}
//#endregion
//#region src/components/ui/input.tsx
function Ii({ className: e, type: t, ...n }) {
	return /* @__PURE__ */ x("input", {
		type: t,
		"data-slot": "input",
		className: q("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", e),
		...n
	});
}
//#endregion
//#region src/components/ui/sidebar.tsx
var Li = "16rem", Ri = "18rem", zi = "3rem", Bi = "b", Vi = a.createContext(null);
function Hi() {
	let e = a.useContext(Vi);
	if (!e) throw Error("useSidebar must be used within a SidebarProvider.");
	return e;
}
function Ui({ defaultOpen: e = !0, open: t, onOpenChange: n, className: r, style: i, children: o, ...s }) {
	let c = Fi(), [l, u] = a.useState(!1), [d, f] = a.useState(e), p = t ?? d, m = a.useCallback((e) => {
		let t = typeof e == "function" ? e(p) : e;
		n ? n(t) : f(t);
	}, [n, p]), h = a.useCallback(() => c ? u((e) => !e) : m((e) => !e), [
		c,
		m,
		u
	]);
	a.useEffect(() => {
		let e = (e) => {
			e.key === Bi && (e.metaKey || e.ctrlKey) && (e.preventDefault(), h());
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, [h]);
	let g = p ? "expanded" : "collapsed", _ = a.useMemo(() => ({
		state: g,
		open: p,
		setOpen: m,
		isMobile: c,
		openMobile: l,
		setOpenMobile: u,
		toggleSidebar: h
	}), [
		g,
		p,
		m,
		c,
		l,
		u,
		h
	]);
	return /* @__PURE__ */ x(Vi.Provider, {
		value: _,
		children: /* @__PURE__ */ x(Dr, {
			delayDuration: 0,
			children: /* @__PURE__ */ x("div", {
				"data-slot": "sidebar-wrapper",
				style: {
					"--sidebar-width": Li,
					"--sidebar-width-icon": zi,
					...i
				},
				className: q("group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full", r),
				...s,
				children: o
			})
		})
	});
}
function Wi({ side: e = "left", variant: t = "sidebar", collapsible: n = "offcanvas", className: r, children: i, ...a }) {
	let { isMobile: o, state: s, openMobile: c, setOpenMobile: l } = Hi();
	return n === "none" ? /* @__PURE__ */ x("div", {
		"data-slot": "sidebar",
		className: q("bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col", r),
		...a,
		children: i
	}) : o ? /* @__PURE__ */ x(ri, {
		open: c,
		onOpenChange: l,
		...a,
		children: /* @__PURE__ */ S(ci, {
			"data-sidebar": "sidebar",
			"data-slot": "sidebar",
			"data-mobile": "true",
			className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
			style: { "--sidebar-width": Ri },
			side: e,
			children: [/* @__PURE__ */ S(li, {
				className: "sr-only",
				children: [/* @__PURE__ */ x(di, { children: "Sidebar" }), /* @__PURE__ */ x(fi, { children: "Displays the mobile sidebar." })]
			}), /* @__PURE__ */ x("div", {
				className: "flex h-full w-full flex-col",
				children: i
			})]
		})
	}) : /* @__PURE__ */ S("div", {
		className: "group peer text-sidebar-foreground hidden md:block",
		"data-state": s,
		"data-collapsible": s === "collapsed" ? n : "",
		"data-variant": t,
		"data-side": e,
		"data-slot": "sidebar",
		children: [/* @__PURE__ */ x("div", {
			"data-slot": "sidebar-gap",
			className: q("relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear", "group-data-[collapsible=offcanvas]:w-0", "group-data-[side=right]:rotate-180", t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)")
		}), /* @__PURE__ */ x("div", {
			"data-slot": "sidebar-container",
			className: q("fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex", e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]", t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l", r),
			...a,
			children: /* @__PURE__ */ x("div", {
				"data-sidebar": "sidebar",
				"data-slot": "sidebar-inner",
				className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm",
				children: i
			})
		})]
	});
}
function Gi({ className: e, onClick: t, ...n }) {
	let { toggleSidebar: r } = Hi();
	return /* @__PURE__ */ S(J, {
		"data-sidebar": "trigger",
		"data-slot": "sidebar-trigger",
		variant: "ghost",
		size: "icon",
		className: q("size-7", e),
		onClick: (e) => {
			t?.(e), r();
		},
		...n,
		children: [/* @__PURE__ */ x(w, { name: "tabler-layout-sidebar" }), /* @__PURE__ */ x("span", {
			className: "sr-only",
			children: "Toggle Sidebar"
		})]
	});
}
function Ki({ className: e, ...t }) {
	let { toggleSidebar: n } = Hi();
	return /* @__PURE__ */ x("button", {
		"data-sidebar": "rail",
		"data-slot": "sidebar-rail",
		"aria-label": "Toggle Sidebar",
		tabIndex: -1,
		onClick: n,
		title: "Toggle Sidebar",
		className: q("hover:after:bg-sidebar-border absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear group-data-[side=left]:-right-4 group-data-[side=right]:left-0 after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] sm:flex", "in-data-[side=left]:cursor-w-resize in-data-[side=right]:cursor-e-resize", "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize", "hover:group-data-[collapsible=offcanvas]:bg-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full", "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2", "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2", e),
		...t
	});
}
function qi({ className: e, ...t }) {
	return /* @__PURE__ */ x("main", {
		"data-slot": "sidebar-inset",
		className: q("bg-background relative flex w-full flex-1 flex-col", "md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2", e),
		...t
	});
}
function Ji({ className: e, ...t }) {
	return /* @__PURE__ */ x(Ii, {
		"data-slot": "sidebar-input",
		"data-sidebar": "input",
		className: q("bg-background h-8 w-full shadow-none", e),
		...t
	});
}
function Yi({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sidebar-header",
		"data-sidebar": "header",
		className: q("flex flex-col gap-2 p-2", e),
		...t
	});
}
function Xi({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sidebar-footer",
		"data-sidebar": "footer",
		className: q("flex flex-col gap-2 p-2", e),
		...t
	});
}
function Zi({ className: e, ...t }) {
	return /* @__PURE__ */ x(Vn, {
		"data-slot": "sidebar-separator",
		"data-sidebar": "separator",
		className: q("bg-sidebar-border mx-2 w-auto", e),
		...t
	});
}
function Qi({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sidebar-content",
		"data-sidebar": "content",
		className: q("flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden", e),
		...t
	});
}
function $i({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sidebar-group",
		"data-sidebar": "group",
		className: q("relative flex w-full min-w-0 flex-col p-2", e),
		...t
	});
}
function ea({ className: e, asChild: t = !1, ...n }) {
	return /* @__PURE__ */ x(t ? O : "div", {
		"data-slot": "sidebar-group-label",
		"data-sidebar": "group-label",
		className: q("text-sidebar-foreground/70 ring-sidebar-ring flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium outline-hidden transition-[margin,opacity] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0", e),
		...n
	});
}
function ta({ className: e, asChild: t = !1, ...n }) {
	return /* @__PURE__ */ x(t ? O : "button", {
		"data-slot": "sidebar-group-action",
		"data-sidebar": "group-action",
		className: q("text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground absolute top-3.5 right-3 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", "after:absolute after:-inset-2 md:after:hidden", "group-data-[collapsible=icon]:hidden", e),
		...n
	});
}
function na({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sidebar-group-content",
		"data-sidebar": "group-content",
		className: q("w-full text-sm", e),
		...t
	});
}
function ra({ className: e, ...t }) {
	return /* @__PURE__ */ x("ul", {
		"data-slot": "sidebar-menu",
		"data-sidebar": "menu",
		className: q("flex w-full min-w-0 flex-col gap-1", e),
		...t
	});
}
function ia({ className: e, ...t }) {
	return /* @__PURE__ */ x("li", {
		"data-slot": "sidebar-menu-item",
		"data-sidebar": "menu-item",
		className: q("group/menu-item relative", e),
		...t
	});
}
var aa = C("peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0", {
	variants: {
		variant: {
			default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
			outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
		},
		size: {
			default: "h-8 text-sm",
			sm: "h-7 text-xs",
			lg: "h-12 text-sm group-data-[collapsible=icon]:p-0!"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function oa({ asChild: e = !1, isActive: t = !1, variant: n = "default", size: r = "default", tooltip: i, className: a, ...o }) {
	let s = e ? O : "button", { isMobile: c, state: l } = Hi(), u = /* @__PURE__ */ x(s, {
		"data-slot": "sidebar-menu-button",
		"data-sidebar": "menu-button",
		"data-size": r,
		"data-active": t,
		className: q(aa({
			variant: n,
			size: r
		}), a),
		...o
	});
	return i ? (typeof i == "string" && (i = { children: i }), /* @__PURE__ */ S(Or, { children: [/* @__PURE__ */ x(kr, {
		asChild: !0,
		children: u
	}), /* @__PURE__ */ x(Ar, {
		side: "right",
		align: "center",
		hidden: l !== "collapsed" || c,
		...i
	})] })) : u;
}
function sa({ className: e, asChild: t = !1, showOnHover: n = !1, ...r }) {
	return /* @__PURE__ */ x(t ? O : "button", {
		"data-slot": "sidebar-menu-action",
		"data-sidebar": "menu-action",
		className: q("text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground peer-hover/menu-button:text-sidebar-accent-foreground absolute top-1.5 right-1 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", "after:absolute after:-inset-2 md:after:hidden", "peer-data-[size=sm]/menu-button:top-1", "peer-data-[size=default]/menu-button:top-1.5", "peer-data-[size=lg]/menu-button:top-2.5", "group-data-[collapsible=icon]:hidden", n && "peer-data-[active=true]/menu-button:text-sidebar-accent-foreground group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 md:opacity-0", e),
		...r
	});
}
function ca({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "sidebar-menu-badge",
		"data-sidebar": "menu-badge",
		className: q("text-sidebar-foreground pointer-events-none absolute right-1 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums select-none", "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground", "peer-data-[size=sm]/menu-button:top-1", "peer-data-[size=default]/menu-button:top-1.5", "peer-data-[size=lg]/menu-button:top-2.5", "group-data-[collapsible=icon]:hidden", e),
		...t
	});
}
function la({ className: e, showIcon: t = !1, ...n }) {
	let r = a.useMemo(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
	return /* @__PURE__ */ S("div", {
		"data-slot": "sidebar-menu-skeleton",
		"data-sidebar": "menu-skeleton",
		className: q("flex h-8 items-center gap-2 rounded-md px-2", e),
		...n,
		children: [t && /* @__PURE__ */ x(Kr, {
			className: "size-4 rounded-md",
			"data-sidebar": "menu-skeleton-icon"
		}), /* @__PURE__ */ x(Kr, {
			className: "h-4 max-w-(--skeleton-width) flex-1",
			"data-sidebar": "menu-skeleton-text",
			style: { "--skeleton-width": r }
		})]
	});
}
function ua({ className: e, ...t }) {
	return /* @__PURE__ */ x("ul", {
		"data-slot": "sidebar-menu-sub",
		"data-sidebar": "menu-sub",
		className: q("border-sidebar-border mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l px-2.5 py-0.5", "group-data-[collapsible=icon]:hidden", e),
		...t
	});
}
function da({ className: e, ...t }) {
	return /* @__PURE__ */ x("li", {
		"data-slot": "sidebar-menu-sub-item",
		"data-sidebar": "menu-sub-item",
		className: q("group/menu-sub-item relative", e),
		...t
	});
}
function fa({ asChild: e = !1, size: t = "md", isActive: n = !1, className: r, ...i }) {
	return /* @__PURE__ */ x(e ? O : "a", {
		"data-slot": "sidebar-menu-sub-button",
		"data-sidebar": "menu-sub-button",
		"data-size": t,
		"data-active": n,
		className: q("text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground [&>svg]:text-sidebar-accent-foreground flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0", "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground", t === "sm" && "text-xs", t === "md" && "text-sm", "group-data-[collapsible=icon]:hidden", r),
		...i
	});
}
//#endregion
//#region src/components/ui/input-group.tsx
function pa({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "input-group",
		role: "group",
		className: q("group/input-group border-input dark:bg-input/30 relative flex w-full items-center rounded-md border shadow-xs transition-[color,box-shadow] outline-none", "h-9 min-w-0 has-[>textarea]:h-auto", "has-[>[data-align=inline-start]]:[&>input]:pl-2", "has-[>[data-align=inline-end]]:[&>input]:pr-2", "has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3", "has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3", "has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot=input-group-control]:focus-visible]:ring-[3px]", "has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[[data-slot][aria-invalid=true]]:border-destructive dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40", e),
		...t
	});
}
var ma = C("text-muted-foreground flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium select-none [&>svg:not([class*='size-'])]:size-4 [&>kbd]:rounded-[calc(var(--radius)-5px)] group-data-[disabled=true]/input-group:opacity-50", {
	variants: { align: {
		"inline-start": "order-first pl-3 has-[>button]:ml-[-0.45rem] has-[>kbd]:ml-[-0.35rem]",
		"inline-end": "order-last pr-3 has-[>button]:mr-[-0.45rem] has-[>kbd]:mr-[-0.35rem]",
		"block-start": "order-first w-full justify-start px-3 pt-3 [.border-b]:pb-3 group-has-[>input]/input-group:pt-2.5",
		"block-end": "order-last w-full justify-start px-3 pb-3 [.border-t]:pt-3 group-has-[>input]/input-group:pb-2.5"
	} },
	defaultVariants: { align: "inline-start" }
});
function ha({ className: e, align: t = "inline-start", ...n }) {
	return /* @__PURE__ */ x("div", {
		role: "group",
		"data-slot": "input-group-addon",
		"data-align": t,
		className: q(ma({ align: t }), e),
		onClick: (e) => {
			e.target.closest("button") || e.currentTarget.parentElement?.querySelector("input")?.focus();
		},
		...n
	});
}
var ga = C("text-sm shadow-none flex gap-2 items-center", {
	variants: { size: {
		xs: "h-6 gap-1 px-2 rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-3.5 has-[>svg]:px-2",
		sm: "h-8 px-2.5 gap-1.5 rounded-md has-[>svg]:px-2.5",
		"icon-xs": "size-6 rounded-[calc(var(--radius)-5px)] p-0 has-[>svg]:p-0",
		"icon-sm": "size-8 p-0 has-[>svg]:p-0"
	} },
	defaultVariants: { size: "xs" }
});
function _a({ className: e, type: t = "button", variant: n = "ghost", size: r = "xs", ...i }) {
	return /* @__PURE__ */ x(J, {
		type: t,
		"data-size": r,
		variant: n,
		className: q(ga({ size: r }), e),
		...i
	});
}
function va({ className: e, ...t }) {
	return /* @__PURE__ */ x("span", {
		className: q("text-muted-foreground flex items-center gap-2 text-sm [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4", e),
		...t
	});
}
function ya({ className: e, ...t }) {
	return /* @__PURE__ */ x(Ii, {
		"data-slot": "input-group-control",
		className: q("flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent", e),
		...t
	});
}
function ba({ className: e, ...t }) {
	return /* @__PURE__ */ x(ar, {
		"data-slot": "input-group-control",
		className: q("flex-1 resize-none rounded-none border-0 bg-transparent py-3 shadow-none focus-visible:ring-0 dark:bg-transparent", e),
		...t
	});
}
//#endregion
//#region src/components/ui/combobox.tsx
var xa = K.Root;
function Sa({ ...e }) {
	return /* @__PURE__ */ x(K.Value, {
		"data-slot": "combobox-value",
		...e
	});
}
function Ca({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ S(K.Trigger, {
		"data-slot": "combobox-trigger",
		className: q("[&_svg:not([class*='size-'])]:size-4", e),
		...n,
		children: [t, /* @__PURE__ */ x(w, {
			name: "tabler-chevron-down",
			"data-slot": "combobox-trigger-icon",
			className: "pointer-events-none size-4 text-muted-foreground"
		})]
	});
}
function wa({ className: e, ...t }) {
	return /* @__PURE__ */ x(K.Clear, {
		"data-slot": "combobox-clear",
		render: /* @__PURE__ */ x(_a, {
			variant: "ghost",
			size: "icon-xs"
		}),
		className: q(e),
		...t,
		children: /* @__PURE__ */ x(w, {
			name: "tabler-x",
			className: "pointer-events-none"
		})
	});
}
function Ta({ className: e, children: t, disabled: n = !1, showTrigger: r = !0, showClear: i = !1, ...a }) {
	return /* @__PURE__ */ S(pa, {
		className: q("w-auto", e),
		children: [
			/* @__PURE__ */ x(K.Input, {
				render: /* @__PURE__ */ x(ya, { disabled: n }),
				...a
			}),
			/* @__PURE__ */ S(ha, {
				align: "inline-end",
				children: [r && /* @__PURE__ */ x(Ca, { render: /* @__PURE__ */ x(_a, {
					size: "icon-xs",
					variant: "ghost",
					"data-slot": "input-group-button",
					className: "group-has-data-[slot=combobox-clear]/input-group:hidden data-pressed:bg-transparent",
					disabled: n
				}) }), i && /* @__PURE__ */ x(wa, { disabled: n })]
			}),
			t
		]
	});
}
function Ea({ className: e, side: t = "bottom", sideOffset: n = 6, align: r = "start", alignOffset: i = 0, anchor: a, container: o, ...s }) {
	return /* @__PURE__ */ x(K.Portal, {
		container: o,
		className: "contents",
		children: /* @__PURE__ */ x(K.Positioner, {
			side: t,
			sideOffset: n,
			align: r,
			alignOffset: i,
			anchor: a,
			className: "isolate z-50",
			children: /* @__PURE__ */ x(K.Popup, {
				"data-slot": "combobox-content",
				"data-chips": !!a,
				className: q("group/combobox-content relative max-h-96 w-(--anchor-width) max-w-(--available-width) min-w-[calc(var(--anchor-width)+--spacing(7))] origin-(--transform-origin) overflow-hidden rounded-md bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[chips=true]:min-w-(--anchor-width) data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 *:data-[slot=input-group]:m-1 *:data-[slot=input-group]:mb-0 *:data-[slot=input-group]:h-8 *:data-[slot=input-group]:border-input/30 *:data-[slot=input-group]:bg-input/30 *:data-[slot=input-group]:shadow-none data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
				...s
			})
		})
	});
}
function Da({ className: e, ...t }) {
	return /* @__PURE__ */ x(K.List, {
		"data-slot": "combobox-list",
		className: q("max-h-[min(calc(--spacing(96)---spacing(9)),calc(var(--available-height)---spacing(9)))] scroll-py-1 overflow-y-auto p-1 data-empty:p-0", e),
		...t
	});
}
function Oa({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ S(K.Item, {
		"data-slot": "combobox-item",
		className: q("relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-highlighted:bg-accent data-highlighted:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
		...n,
		children: [t, /* @__PURE__ */ x(K.ItemIndicator, {
			"data-slot": "combobox-item-indicator",
			render: /* @__PURE__ */ x("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center" }),
			children: /* @__PURE__ */ x(w, {
				name: "tabler-check",
				className: "pointer-events-none size-4 pointer-coarse:size-5"
			})
		})]
	});
}
function ka({ className: e, ...t }) {
	return /* @__PURE__ */ x(K.Group, {
		"data-slot": "combobox-group",
		className: q(e),
		...t
	});
}
function Aa({ className: e, ...t }) {
	return /* @__PURE__ */ x(K.GroupLabel, {
		"data-slot": "combobox-label",
		className: q("px-2 py-1.5 text-xs text-muted-foreground pointer-coarse:px-3 pointer-coarse:py-2 pointer-coarse:text-sm", e),
		...t
	});
}
function ja({ ...e }) {
	return /* @__PURE__ */ x(K.Collection, {
		"data-slot": "combobox-collection",
		...e
	});
}
function Ma({ className: e, ...t }) {
	return /* @__PURE__ */ x(K.Empty, {
		"data-slot": "combobox-empty",
		className: q("hidden w-full justify-center py-2 text-center text-sm text-muted-foreground group-data-empty/combobox-content:flex", e),
		...t
	});
}
function Na({ className: e, ...t }) {
	return /* @__PURE__ */ x(K.Separator, {
		"data-slot": "combobox-separator",
		className: q("-mx-1 my-1 h-px bg-border", e),
		...t
	});
}
function Pa({ className: e, ...t }) {
	return /* @__PURE__ */ x(K.Chips, {
		"data-slot": "combobox-chips",
		className: q("flex min-h-9 flex-wrap items-center gap-1.5 rounded-md border border-input bg-transparent bg-clip-padding px-2.5 py-1.5 text-sm shadow-xs transition-[color,box-shadow] focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/50 has-aria-invalid:border-destructive has-aria-invalid:ring-[3px] has-aria-invalid:ring-destructive/20 has-data-[slot=combobox-chip]:px-1.5 dark:bg-input/30 dark:has-aria-invalid:border-destructive/50 dark:has-aria-invalid:ring-destructive/40", e),
		...t
	});
}
function Fa({ className: e, children: t, showRemove: n = !0, ...r }) {
	return /* @__PURE__ */ S(K.Chip, {
		"data-slot": "combobox-chip",
		className: q("flex h-[calc(--spacing(5.5))] w-fit items-center justify-center gap-1 rounded-sm bg-muted px-1.5 text-xs font-medium whitespace-nowrap text-foreground has-disabled:pointer-events-none has-disabled:cursor-not-allowed has-disabled:opacity-50 has-data-[slot=combobox-chip-remove]:pr-0", e),
		...r,
		children: [t, n && /* @__PURE__ */ x(K.ChipRemove, {
			render: /* @__PURE__ */ x(J, {
				variant: "ghost",
				size: "icon-xs"
			}),
			className: "-ml-1 opacity-50 hover:opacity-100",
			"data-slot": "combobox-chip-remove",
			children: /* @__PURE__ */ x(w, {
				name: "tabler-x",
				className: "pointer-events-none"
			})
		})]
	});
}
function Ia({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ x(K.Input, {
		"data-slot": "combobox-chip-input",
		className: q("min-w-16 flex-1 outline-none", e),
		...n
	});
}
function La() {
	return a.useRef(null);
}
//#endregion
//#region src/components/ui/number-field.tsx
function Ra({ className: e, ...t }) {
	return /* @__PURE__ */ x(Te.Root, {
		"data-slot": "number-field",
		className: q("w-full", e),
		...t
	});
}
function za({ className: e, ...t }) {
	return /* @__PURE__ */ x(Te.Group, {
		"data-slot": "number-field-group",
		className: q("border-input dark:bg-input/30 flex h-9 w-full min-w-0 items-center overflow-hidden rounded-md border text-base shadow-xs transition-[color,box-shadow] md:text-sm", "focus-within:border-ring focus-within:ring-ring/50 focus-within:ring-[3px]", "has-[[aria-invalid=true]]:border-destructive has-[[aria-invalid=true]]:ring-destructive/20 dark:has-[[aria-invalid=true]]:ring-destructive/40", "data-disabled:pointer-events-none data-disabled:opacity-50", e),
		...t
	});
}
function Ba({ className: e, ...t }) {
	return /* @__PURE__ */ x(Te.Input, {
		"data-slot": "number-field-input",
		className: q("placeholder:text-muted-foreground h-full w-full min-w-0 flex-1 bg-transparent px-3 tabular-nums outline-none", e),
		...t
	});
}
function Va({ className: e, ...t }) {
	return /* @__PURE__ */ x(Te.Decrement, {
		"data-slot": "number-field-decrement",
		className: q("text-muted-foreground hover:bg-accent hover:text-foreground flex h-full shrink-0 cursor-pointer items-center justify-center px-2.5 transition-colors disabled:cursor-not-allowed disabled:opacity-50", e),
		...t,
		children: /* @__PURE__ */ x(w, {
			name: "tabler-minus",
			className: "size-4"
		})
	});
}
function Ha({ className: e, ...t }) {
	return /* @__PURE__ */ x(Te.Increment, {
		"data-slot": "number-field-increment",
		className: q("text-muted-foreground hover:bg-accent hover:text-foreground flex h-full shrink-0 cursor-pointer items-center justify-center px-2.5 transition-colors disabled:cursor-not-allowed disabled:opacity-50", e),
		...t,
		children: /* @__PURE__ */ x(w, {
			name: "tabler-plus",
			className: "size-4"
		})
	});
}
//#endregion
//#region src/components/ui/button-group.tsx
var Ua = C("flex w-fit items-stretch [&>*]:focus-visible:z-10 [&>*]:focus-visible:relative [&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit [&>input]:flex-1 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-md has-[>[data-slot=button-group]]:gap-2", {
	variants: { orientation: {
		horizontal: "[&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:border-l-0 [&>*:not(:last-child)]:rounded-r-none",
		vertical: "flex-col [&>*:not(:first-child)]:rounded-t-none [&>*:not(:first-child)]:border-t-0 [&>*:not(:last-child)]:rounded-b-none"
	} },
	defaultVariants: { orientation: "horizontal" }
});
function Wa({ className: e, orientation: t, ...n }) {
	return /* @__PURE__ */ x("div", {
		role: "group",
		"data-slot": "button-group",
		"data-orientation": t,
		className: q(Ua({ orientation: t }), e),
		...n
	});
}
function Ga({ className: e, asChild: t = !1, ...n }) {
	return /* @__PURE__ */ x(t ? O : "div", {
		className: q("bg-muted flex items-center gap-2 rounded-md border px-4 text-sm font-medium shadow-xs [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4", e),
		...n
	});
}
function Ka({ className: e, orientation: t = "vertical", ...n }) {
	return /* @__PURE__ */ x(Vn, {
		"data-slot": "button-group-separator",
		orientation: t,
		className: q("bg-input relative !m-0 self-stretch data-[orientation=vertical]:h-auto", e),
		...n
	});
}
//#endregion
//#region src/components/ui/item.tsx
var qa = C("group/item flex flex-wrap items-center rounded-md border border-transparent text-sm outline-none transition-colors duration-100 [a]:transition-colors [a]:hover:bg-accent/50 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", {
	variants: {
		variant: {
			default: "bg-transparent",
			outline: "border-border",
			muted: "bg-muted/50"
		},
		size: {
			default: "gap-4 p-4",
			sm: "gap-2.5 px-4 py-3",
			xs: "gap-2 px-3 py-2"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function Ja({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		role: "list",
		"data-slot": "item-group",
		className: q("group/item-group flex flex-col", e),
		...t
	});
}
function Ya({ className: e, ...t }) {
	return /* @__PURE__ */ x(Vn, {
		"data-slot": "item-separator",
		orientation: "horizontal",
		className: q("my-0", e),
		...t
	});
}
function Xa({ className: e, variant: t = "default", size: n = "default", asChild: r = !1, ...i }) {
	return /* @__PURE__ */ x(r ? O : "div", {
		"data-slot": "item",
		"data-variant": t,
		"data-size": n,
		className: q(qa({
			variant: t,
			size: n,
			className: e
		})),
		...i
	});
}
var Za = C("flex shrink-0 items-center justify-center gap-2 group-has-[[data-slot=item-description]]/item:self-start group-has-[[data-slot=item-description]]/item:translate-y-0.5 [&_svg]:pointer-events-none", {
	variants: { variant: {
		default: "bg-transparent",
		icon: "size-8 rounded-sm border bg-muted [&_svg:not([class*='size-'])]:size-4",
		image: "size-10 overflow-hidden rounded-sm [&_img]:size-full [&_img]:object-cover"
	} },
	defaultVariants: { variant: "default" }
});
function Qa({ className: e, variant: t = "default", ...n }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "item-media",
		"data-variant": t,
		className: q(Za({
			variant: t,
			className: e
		})),
		...n
	});
}
function $a({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "item-content",
		className: q("flex flex-1 flex-col gap-1 [&+[data-slot=item-content]]:flex-none", e),
		...t
	});
}
function eo({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "item-title",
		className: q("flex w-fit items-center gap-2 text-sm font-medium leading-snug", e),
		...t
	});
}
function to({ className: e, ...t }) {
	return /* @__PURE__ */ x("p", {
		"data-slot": "item-description",
		className: q("line-clamp-2 text-balance text-sm font-normal leading-normal text-muted-foreground", "[&>a:hover]:text-primary [&>a]:underline [&>a]:underline-offset-4", e),
		...t
	});
}
function no({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "item-actions",
		className: q("flex items-center gap-2", e),
		...t
	});
}
function ro({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "item-header",
		className: q("flex basis-full items-center justify-between gap-2", e),
		...t
	});
}
function io({ className: e, ...t }) {
	return /* @__PURE__ */ x("div", {
		"data-slot": "item-footer",
		className: q("flex basis-full items-center justify-between gap-2", e),
		...t
	});
}
//#endregion
//#region src/components/ui-composite/button.tsx
var ao = u(function({ children: e, loading: t, ...n }, r) {
	let i = oo(e), a = t ? /* @__PURE__ */ x("span", {
		"data-loading-indicator": !0,
		className: "visible absolute inset-0 ml-0! flex items-center justify-center",
		children: /* @__PURE__ */ x(w, {
			name: "tabler-loader-2",
			className: "size-4 animate-spin"
		})
	}) : null, o = n.asChild && t && d(e) ? c(e, void 0, /* @__PURE__ */ S(b, { children: [oo(e.props.children), a] })) : n.asChild ? e : /* @__PURE__ */ S(b, { children: [i, a] });
	return /* @__PURE__ */ x(J, {
		...n,
		"aria-busy": t || void 0,
		className: q("relative", { "[&>:not([data-loading-indicator])]:invisible": t }, n.className),
		ref: r,
		children: o
	});
});
function oo(e) {
	return s.map(e, (e) => typeof e == "string" || typeof e == "number" ? /* @__PURE__ */ x("span", { children: e }) : e);
}
//#endregion
//#region src/components/ui/checkbox.tsx
var so = a.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x(Ee.Root, {
	ref: n,
	className: q("peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", e),
	...t,
	children: /* @__PURE__ */ x(Ee.Indicator, {
		className: q("flex items-center justify-center text-current"),
		children: /* @__PURE__ */ x(w, {
			name: "tabler-check",
			className: "h-4 w-4"
		})
	})
}));
so.displayName = Ee.Root.displayName;
//#endregion
//#region src/components/ui-composite/checkbox.tsx
var co = a.forwardRef((e, t) => /* @__PURE__ */ x(so, {
	...e,
	ref: t,
	className: q("rounded-[4px]", e.className)
})), lo = class {
	static {
		this._ctx = null;
	}
	static create() {
		return this._ctx ||= l(null), this._ctx;
	}
};
function uo() {
	return lo.create();
}
function fo() {
	let e = f(uo());
	return re(e !== null, "useComboboxContext must be used within a ComboboxContextProvider"), e;
}
//#endregion
//#region src/components/ui-composite/Combobox/Combobox.tsx
function po(e) {
	let t = fo(), [n, r] = y(!1);
	return /* @__PURE__ */ S(Z, {
		open: n,
		onOpenChange: r,
		modal: e.modal,
		children: [/* @__PURE__ */ x(Cn, {
			asChild: !0,
			children: /* @__PURE__ */ S(ao, {
				variant: "outline",
				role: "combobox",
				"aria-expanded": n,
				className: q("flex w-full justify-between ", e.triggerClassName),
				children: [/* @__PURE__ */ x("span", {
					className: "truncate",
					children: t.getValueDisplay()
				}), /* @__PURE__ */ x(w, {
					name: "tabler-chevron-down",
					className: "ml-2 h-4 w-4 shrink-0 opacity-50"
				})]
			})
		}), /* @__PURE__ */ x(Q, {
			className: "w-full p-0  w-(--radix-popover-trigger-width)",
			children: /* @__PURE__ */ S(Dt, { children: [
				/* @__PURE__ */ x(kt, { placeholder: e.searchPlaceholder }),
				/* @__PURE__ */ x(jt, { children: e.notFoundText }),
				/* @__PURE__ */ x(Y, { children: /* @__PURE__ */ x(At, {
					className: "max-h-[200px] overflow-auto",
					children: t.options.map((e) => /* @__PURE__ */ x(t.Option, {
						option: e,
						isSelected: t.getIsSelected(e),
						onSelect: (e) => {
							t.toggle(e), r(!1);
						}
					}, e.id))
				}) })
			] })
		})]
	});
}
//#endregion
//#region src/components/ui-composite/Combobox/DefaultOption.tsx
function mo(e) {
	return /* @__PURE__ */ S(X, {
		onSelect: () => {
			e.onSelect(e.option);
		},
		disabled: e.isDisabled,
		children: [/* @__PURE__ */ x(w, {
			name: "tabler-check",
			className: q("mr-2 h-4 w-4", e.isSelected ? "opacity-100" : "opacity-0")
		}), e.option.label]
	}, e.option.id);
}
//#endregion
//#region src/components/ui-composite/Combobox/MultiSelectComboboxProvider.tsx
function ho({ children: e, Option: t, ...n }) {
	let r = uo(), i = _(() => ({
		...n,
		Option: t ?? mo,
		getIsSelected: o,
		getValueDisplay: a,
		toggle: s,
		select: l,
		deselect: c
	}), [n, t]);
	return /* @__PURE__ */ x(r.Provider, {
		value: i,
		children: e(i)
	});
	function a() {
		return n.placeholder;
	}
	function o(e) {
		return n.value.some((t) => t.id === e.id);
	}
	function s(e) {
		o(e) ? c(e) : l(e);
	}
	function c(e) {
		n.onChange(n.value.filter((t) => t.id !== e.id));
	}
	function l(e) {
		n.onChange([...n.value, e]);
	}
}
//#endregion
//#region src/components/ui-composite/Combobox/SingleSelectComboboxProvider.tsx
function go(e) {
	return /* @__PURE__ */ x(uo().Provider, {
		value: {
			...e,
			getIsSelected: n,
			getValueDisplay: t,
			toggle: r,
			select: i,
			deselect: a
		},
		children: e.children
	});
	function t() {
		return e.value?.label ?? e.placeholder;
	}
	function n(t) {
		return e.value?.id === t.id;
	}
	function r(e) {
		n(e) ? a() : i(e);
	}
	function i(t) {
		e.onChange(t);
	}
	function a() {
		e.onChange(null);
	}
}
//#endregion
//#region src/components/ui-composite/DateRangePicker.tsx
function _o(e) {
	return !!(e && e.from && e.to);
}
function vo(e) {
	let [t, n] = y(!1), [r, i] = y(e.value), a = () => {
		_o(r) && (e.onChange(r), n(!1));
	}, o = () => {
		i(e.value), n(!1);
	};
	function s(e) {
		return `${e.from.toLocaleDateString()} - ${e.to.toLocaleDateString()}`;
	}
	return /* @__PURE__ */ S(Z, {
		open: t,
		onOpenChange: n,
		children: [/* @__PURE__ */ x(Cn, {
			asChild: !0,
			children: /* @__PURE__ */ S(J, {
				variant: "outline",
				className: q("w-full justify-between text-left font-normal", e.className),
				children: [s(e.value), /* @__PURE__ */ x(w, {
					name: "tabler-chevron-down",
					className: "ml-2 h-4 w-4 opacity-50"
				})]
			})
		}), /* @__PURE__ */ x(Q, {
			className: "w-auto p-0",
			align: "start",
			children: /* @__PURE__ */ S("div", {
				className: "flex flex-col gap-1",
				children: [
					/* @__PURE__ */ S("div", {
						className: "grid grid-cols-2 gap-2 text-xs text-muted-foreground pt-4 px-4",
						children: [/* @__PURE__ */ x("div", { children: e.startDateLabel || "Start Date" }), /* @__PURE__ */ x("div", { children: e.endDateLabel || "End Date" })]
					}),
					/* @__PURE__ */ S("div", {
						className: "flex gap-2 px-4",
						children: [/* @__PURE__ */ x(J, {
							variant: "outline",
							size: "sm",
							className: "flex-1 cursor-default",
							disabled: !0,
							children: r?.from?.toLocaleDateString()
						}), /* @__PURE__ */ x(J, {
							variant: "outline",
							size: "sm",
							className: "flex-1 cursor-default",
							disabled: !0,
							children: r?.to?.toLocaleDateString()
						})]
					}),
					/* @__PURE__ */ x($e, {
						mode: "range",
						selected: r,
						onSelect: (e) => {
							i(e);
						},
						numberOfMonths: 1
					}),
					/* @__PURE__ */ S("div", {
						className: "flex gap-2 p-4 border-t",
						children: [/* @__PURE__ */ x(J, {
							variant: "outline",
							onClick: o,
							className: "flex-1",
							children: e.cancelLabel || "Cancel"
						}), /* @__PURE__ */ x(J, {
							onClick: a,
							disabled: !_o(r),
							className: "flex-1",
							children: e.applyLabel || "Apply"
						})]
					})
				]
			})
		})]
	});
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/date-to-calendar-date-time.ts
function yo(e) {
	return new Fe(e.getFullYear(), e.getMonth() + 1, e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function bo(e) {
	return new Ie(e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/DateSegment.tsx
var xo = (e) => {
	let { segment: t, state: n } = e, r = o.useRef(null), { segmentProps: i } = ze(t, n, r);
	return /* @__PURE__ */ x("div", {
		...i,
		className: q("focus:bg-accent focus:text-accent-foreground group box-content flex items-center justify-center rounded-sm px-0.5 text-right tabular-nums outline-none", t.isEditable ? "text-foreground" : "text-muted-foreground"),
		ref: r,
		style: {
			...i.style,
			minWidth: t.maxValue ? `${String(t.maxValue).length}ch` : void 0
		},
		children: t.isPlaceholder ? /* @__PURE__ */ x("span", {
			"aria-hidden": "true",
			className: "text-muted-foreground group-focus:text-accent-foreground block w-full text-center italic",
			style: { pointerEvents: "none" },
			children: t.placeholder
		}) : t.text
	});
};
//#endregion
//#region src/components/ui-composite/DateTimePicker/format-date-field-segments.ts
function So(e) {
	let t = e.reduce((e, t) => t.type === "day" || t.type === "month" ? [...e, {
		...t,
		text: t.text.padStart(2, "0")
	}] : t.type === "literal" ? [...e, {
		...t,
		text: "/"
	}] : t.type === "hour" || t.type === "minute" || t.type === "dayPeriod" ? e : [...e, t], []);
	for (; t.length > 0 && t[t.length - 1].type === "literal";) t.pop();
	return t;
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/DateField.tsx
function Co(e) {
	let { children: t, childrenAfter: n, className: r, ...i } = e, a = o.useRef(null), s = Be(), c = e.locale || s.locale, l = Ne({
		...i,
		locale: c,
		createCalendar: Le
	}), { fieldProps: u } = Re(i, l, a), d = So(l.segments);
	return /* @__PURE__ */ S("div", {
		className: "relative flex items-center gap-2",
		children: [
			t,
			!e.hideSegments && /* @__PURE__ */ x("div", {
				...u,
				className: q("border-input placeholder:text-muted-foreground focus-visible:ring-ring flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50", i.isDisabled ? "cursor-not-allowed opacity-50" : "", r),
				ref: a,
				children: d.map((e, t) => /* @__PURE__ */ x(xo, {
					segment: e,
					state: l
				}, t))
			}),
			n
		]
	});
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/normalizeTime.ts
function wo(e) {
	e = e.trim().toLowerCase();
	let t = "";
	(e.endsWith("am") || e.endsWith("pm")) && (t = e.slice(-2), e = e.slice(0, -2).trim()), e.includes(":") || (e += ":00"), e.endsWith(":") && (e += "00");
	let n = e.split(":");
	if (n.length !== 2) return e;
	let r = String(parseInt(n[0], 10)), i = n[1];
	return r + ":" + i + t;
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/timeToMinutes.ts
function To(e) {
	let t = e.match(/^(\d{1,2}):?(\d{2})?(?:am|pm)?$/i);
	if (!t) return null;
	let n = parseInt(t[1], 10), r = parseInt(t[2] || "0", 10);
	return e.toLowerCase().includes("pm") && n !== 12 ? n += 12 : e.toLowerCase().includes("am") && n === 12 && (n = 0), n >= 24 || r >= 60 ? null : n * 60 + r;
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/findClosestTimeMatch.ts
function Eo(e) {
	let t = e.split(":");
	return t.length === 2 && t[1].length === 1 ? `${t[0]}:${t[1]}0` : e;
}
function Do(e, t, n = !1) {
	if (e === "0") return t[0];
	let r = To(wo(Eo(e)));
	if (r === null) return null;
	let i = null, a = Infinity;
	return n ? t.find((e) => To(wo(e.label)) === r) || null : (t.forEach((e) => {
		let t = To(wo(e.label));
		if (t === null) return;
		let n = Math.abs(t - r);
		n < a && (a = n, i = e);
	}), i);
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/formatTime.ts
function Oo(e, t) {
	let n = e.match(/^\s*(\d{1,2}):(\d{2})(?:\s*([ap]m))?\s*$/i);
	if (!n) throw Error("Invalid time format");
	let r = parseInt(n[1], 10), i = parseInt(n[2], 10), a = n[3] ? n[3].toLowerCase() : null;
	if (a && (a === "pm" && r < 12 ? r += 12 : a === "am" && r === 12 && (r = 0)), t === "metric") return `${r.toString().padStart(2, "0")}:${i.toString().padStart(2, "0")}`;
	if (t === "imperial") {
		let e = r < 12, t = r % 12;
		t === 0 && (t = 12);
		let n = i.toString().padStart(2, "0");
		return `${t}:${n}${e ? "am" : "pm"}`;
	}
	throw Error("Unsupported locale");
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/generateTimeEntries.ts
function ko(e) {
	let [t, n] = e.split(":").map(Number);
	return t * 60 + n;
}
function Ao(e, t) {
	return ko(e) >= t;
}
function jo(e, t = 0) {
	let n = [], r = [], i = Array.from({ length: 60 / e }, (t, n) => n * e);
	for (let e = 0; e < 24; e++) for (let a of i) {
		let i = `${e.toString().padStart(2, "0")}:${a.toString().padStart(2, "0")}`;
		if (!Ao(i, t)) continue;
		let o = i;
		r.push({
			label: o,
			value: i
		});
		let s = e >= 12 ? "pm" : "am", c = e % 12;
		c = c === 0 ? 12 : c;
		let l = `${c}:${a.toString().padStart(2, "0")}${s}`;
		n.push({
			label: l,
			value: i
		});
	}
	return {
		imperial: n,
		metric: r
	};
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/getMeasurementSystem.ts
function Mo(e) {
	let [t, n] = e.toLowerCase().split("-");
	return t === "en" && (!n || n === "us") ? "imperial" : "metric";
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/parseTime.ts
function No(e) {
	e = e.trim();
	let t = null, n = e.toLowerCase();
	(n.endsWith("am") || n.endsWith("pm")) && (t = n.slice(-2), e = e.slice(0, -2).trim());
	let r = e.split(":");
	if (r.length !== 2) throw Error("Invalid time format. Expected format HH:MM or HH:MMam/pm.");
	let i = parseInt(r[0], 10), a = parseInt(r[1], 10);
	return t && (t === "am" ? i === 12 && (i = 0) : t === "pm" && i !== 12 && (i += 12)), {
		hour: i,
		minute: a
	};
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/validateTimeString.ts
function Po(e) {
	let t = e.trim();
	if (/^\d{2}$/.test(t)) {
		let e = Number(t);
		return e >= 0 && e <= 23 ? `${e}:00` : null;
	}
	if (/^(0?\d|1\d|2[0-3])$/.test(t)) return `${Number(t)}:00`;
	let n = t.match(/^(\d{3,4})([ap]m?)?$/i);
	if (n) {
		let e = n[1], t = n[2]?.toLowerCase(), r, i;
		if (e.length === 3 ? (r = Number(e[0]), i = Number(e.slice(1))) : (r = Number(e.slice(0, 2)), i = Number(e.slice(2))), t && (r < 1 || r > 12) || !t && (r < 0 || r > 23) || i > 59) return null;
		let a = i.toString().padStart(2, "0");
		return t ? `${r}:${a}${t.length === 1 ? t + "m" : t}` : `${r}:${a}`;
	}
	if (/[ap]/i.test(t)) {
		let e = t.match(/^0?([1-9]|1[0-2])[;:]([0-5]\d|[0-5])([ap])(m?)$/i);
		if (e) {
			let t = Number(e[1]), n = e[2];
			n = n.length === 1 ? n + "0" : n;
			let r = e[3].toLowerCase() + "m";
			return `${t}:${n}${r}`;
		}
		return null;
	} else {
		let e = t.match(/^(0?\d|1\d|2[0-3])[;:]([0-5]\d|[0-5])$/);
		if (e) {
			let t = Number(e[1]), n = e[2];
			return n = n.length === 1 ? n + "0" : n, `${t}:${n}`;
		}
		return null;
	}
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/TimeField/TimeField.tsx
var Fo = "default" in Ve ? Ve.default : Ve, Io = o.forwardRef((e, t) => {
	let [n, r] = o.useState(!1);
	return o.useEffect(() => {
		r(!0);
	}, []), n ? /* @__PURE__ */ x(Fo, { ...e }) : /* @__PURE__ */ x("div", {
		ref: e.inputRef,
		className: e.inputClassName
	});
});
Io.displayName = "ClientSideAutosizeInput";
function Lo(e) {
	let t = _(() => jo(15, e.min), [e.min]), n = v(null), r = v(null), i = v(null), [a, s] = o.useState(!1), [c, l] = o.useState(null);
	function u() {
		return e.value ? Oo(`${e.value.hour.toString().padStart(2, "0")}:${e.value.minute.toString().padStart(2, "0")}`, Mo(e.locale || "en-US")) : "";
	}
	let [d, f] = o.useState(() => u());
	p(() => {
		f(u());
	}, [e.value?.hour, e.value?.minute]);
	let m = Mo(e.locale || "en-US"), h = m === "imperial" ? t.imperial : t.metric, g = Do(d, h), y = d === "" || g || Po(d);
	function b(t) {
		f(t), e.onChange?.(No(t));
	}
	function C() {
		s(!0);
	}
	function ee(e, t = !1) {
		if (!e?.value) return;
		let n = i.current?.querySelector(`[data-value="${e.value}"]`);
		n && (n.scrollIntoView(), t && n.dispatchEvent(new PointerEvent("pointermove", {
			bubbles: !0,
			cancelable: !0
		})));
	}
	return /* @__PURE__ */ S(Z, {
		open: a,
		modal: e.modal,
		children: [/* @__PURE__ */ x(Tn, { children: /* @__PURE__ */ S("div", {
			className: q("px-[16px] bg-[#f7f7f7] h-[40px] flex items-center rounded-[4px] group relative", { "border border-solid border-[#B3251E] bg-[#FADEDC]": e.isInvalid || !y }, e.className),
			ref: l,
			children: [/* @__PURE__ */ x(Io, {
				inputRef: (e) => {
					n.current = e;
				},
				className: "min-w-[60px] !inline-flex justify-center",
				inputClassName: "h-[24px] bg-inherit outline-none leading-[16px] border-none p-0 ",
				placeholder: "hh:mm",
				value: d,
				onBlur: () => {
					let e = Po(d);
					if (!e) return;
					let t = Oo(e, m);
					t && (b(t), s(!1));
				},
				onChange: (e) => {
					i?.current?.querySelector("[data-value=\"EMPTY\"]")?.dispatchEvent(new PointerEvent("pointermove", {
						bubbles: !0,
						cancelable: !0
					})), C();
					let t = e.target.value;
					f(t);
					let n = Po(t);
					if (!n) return;
					let r = Do(n, h, !0);
					if (r) ee(r, !0);
					else {
						let e = Do(n, h);
						e && ee(e);
					}
				},
				onClick: (e) => {
					e.currentTarget.select(), C();
				},
				onFocus: (e) => {
					e.target.select();
				},
				onKeyDown: (e) => {
					e.key === "Enter" && e.preventDefault();
					let t = (i.current?.querySelector("[data-selected=\"true\"]"))?.getAttribute("data-value") !== "EMPTY";
					if (e.key == "Enter" && !t && !Do(d, h, !0)) {
						let e = Po(d);
						if (e) {
							b(Oo(e, m)), s(!1);
							return;
						}
					}
					let n = new KeyboardEvent("keydown", {
						key: e.key,
						code: e.code,
						shiftKey: e.shiftKey,
						ctrlKey: e.ctrlKey,
						metaKey: e.metaKey,
						altKey: e.altKey,
						bubbles: !0,
						cancelable: !0
					});
					r.current?.dispatchEvent(n), (e.key === "ArrowDown" || e.key === "ArrowUp") && (e.key === "ArrowDown" && !a && C(), e.preventDefault()), e.key === "Escape" && s(!1);
				}
			}), /* @__PURE__ */ x("div", { className: "absolute bottom-0 h-[2px] bg-active-primary hidden left-0 right-0 group-focus-within:block rounded-b-[4px]" })]
		}) }), /* @__PURE__ */ x(Q, {
			className: "p-0 max-w-[180px] rounded-[4px]",
			onOpenAutoFocus: (e) => {
				e.preventDefault();
			},
			autoFocus: !1,
			onFocusOutside: (e) => {
				if (c?.contains(e.target)) return e.preventDefault();
				s(!1);
			},
			align: "start",
			children: /* @__PURE__ */ x(Ro, {
				handleTimeChange: b,
				setOpen: s,
				timeOptions: h,
				cmdInputRef: r,
				scrollRef: i,
				closeMatch: g,
				time: d,
				modal: e.modal
			})
		})]
	});
}
function Ro(e) {
	return g(() => {
		setTimeout(() => {
			if (!e.closeMatch) return;
			let t = e.scrollRef.current?.querySelector(`[data-value="${e.closeMatch?.value}"]`);
			t && (t.scrollIntoView(), Do(e.time, e.timeOptions, !0) && t.dispatchEvent(new PointerEvent("pointermove", {
				bubbles: !0,
				cancelable: !0
			})));
		});
	}, []), /* @__PURE__ */ S(Dt, {
		className: "rounded-[4px]",
		children: [/* @__PURE__ */ x("div", {
			className: "hidden",
			children: /* @__PURE__ */ x(kt, { ref: e.cmdInputRef })
		}), /* @__PURE__ */ x(At, {
			className: "max-h-[200px]  p-0",
			ref: e.scrollRef,
			children: /* @__PURE__ */ S(Y, {
				className: "p-0",
				children: [e.timeOptions.map((t) => /* @__PURE__ */ x(X, {
					value: String(t.value),
					className: "rounded-none px-4",
					onSelect: (t) => {
						let n = e.timeOptions.find((e) => e.value === t);
						n && (e.handleTimeChange(n.label), e.setOpen(!1));
					},
					children: t.label
				}, t.value)), /* @__PURE__ */ x(X, {
					value: "EMPTY",
					className: "hidden"
				})]
			})
		})]
	});
}
//#endregion
//#region src/components/ui-composite/DateTimePicker/index.tsx
function $(e, t) {
	return T(je(e ?? /* @__PURE__ */ new Date(0), {
		hours: t?.hour || 0,
		minutes: t?.minute || 0,
		seconds: 0,
		milliseconds: +!!t
	}));
}
function zo(e, t) {
	if (t in e) return e[t] ? bo(e[t]) : e[t] || null;
	let n = t === "timeDate" ? "date" : "endDate";
	if (e[n]) {
		let t = E(e[n]) ? void 0 : ie(e[n]);
		return t ? bo(t) : null;
	}
	return null;
}
function Bo(e) {
	let [t, n] = o.useState(() => zo(e, "timeDate")), [r, i] = o.useState(() => zo(e, "endTimeDate")), [a, s] = o.useState(e.date ? ie(e.date) : null), [c, l] = o.useState(e.endDate ? ie(e.endDate) : e.date ? ie(e.date) : null);
	return {
		date: a,
		endDate: c,
		endTimeValue: r,
		timeValue: t,
		setTimeValue: (e) => {
			n(e);
		},
		setEndTimeValue: (e) => {
			i(e);
		},
		setEndDate: (e) => {
			l(e);
		},
		setDate: (e) => {
			s(e);
		},
		setTime: (e) => {
			Me(() => {
				n(e.start), i(e.end);
			});
		},
		get formattedDate() {
			return $(this.date, this.timeValue);
		},
		get endFormattedDate() {
			return this.endTimeValue === null ? null : $(this.endDate, this.endTimeValue);
		},
		get isEndFormattedDateValid() {
			return this.endDate === null ? !1 : Uo(this.formattedDate, this.endFormattedDate);
		}
	};
}
var Vo = (e) => {
	let t = o.useRef(null), [n, r] = o.useState(!1);
	function i(t) {
		let n = Intl.DateTimeFormat().resolvedOptions().timeZone, r = t == null ? null : t.toDate(n);
		e.value.setDate(r);
	}
	return /* @__PURE__ */ S(b, { children: [
		/* @__PURE__ */ S(Z, {
			"aria-label": "Date Time Picker",
			open: n,
			onOpenChange: r,
			children: [/* @__PURE__ */ x(Co, {
				onChange: Pe({
					value: e.value?.date == null ? void 0 : yo(e.value.date),
					onChange: i,
					isDisabled: e.isDisabled,
					granularity: "minute"
				}).setValue,
				value: e.value.date ? yo(e.value.date) : void 0,
				locale: e.locale,
				hideSegments: !!e.renderDate,
				children: /* @__PURE__ */ x(Cn, {
					asChild: !0,
					disabled: e.disableDate,
					children: /* @__PURE__ */ S("button", {
						className: "flex cursor-pointer items-center gap-2",
						type: "button",
						children: [/* @__PURE__ */ x(w, {
							name: "tabler-calendar",
							className: "h-4 w-4"
						}), e.value.date && e.renderDate?.(e.value.date)]
					})
				})
			}), /* @__PURE__ */ x(Q, {
				align: "start",
				className: "w-auto",
				ref: t,
				children: /* @__PURE__ */ x($e, {
					initialFocus: !0,
					mode: "single",
					onSelect: (t) => {
						i(t == null ? null : yo(t)), e.onChange?.({
							date: t,
							timeValue: e.value.timeValue,
							get formattedDate() {
								return $(this.date, this.timeValue);
							},
							get endFormattedDate() {
								return $(e.value.endDate, e.value.endTimeValue);
							},
							get isEndFormattedDateValid() {
								return Uo(this.formattedDate, this.endFormattedDate);
							}
						}), r(!1);
					},
					selected: e.value.date || void 0
				})
			})]
		}),
		e.type !== "date-only" && /* @__PURE__ */ x(Lo, {
			"aria-label": "Start Time Picker",
			locale: e.locale,
			value: e.value.timeValue,
			isInvalid: e.invalidStartTime,
			onChange: (t) => {
				let n = Ho(e.value?.date, t), r = null, i = null;
				function a() {
					i = De(n, 60);
					let e = Oe(n);
					ke(i, e) || (r = {
						hour: i.getHours(),
						minute: i.getMinutes()
					});
				}
				e.value.endDate && !ke(e.value.endDate, n) && a(), e.value.setTime({
					start: t,
					end: r || e.value.endTimeValue
				}), e.onChange?.({
					type: r ? "both" : "start",
					date: n,
					timeValue: t,
					get formattedDate() {
						return this.date === null ? null : $(this.date, this.timeValue);
					},
					get endFormattedDate() {
						return !i && !e.value.endDate ? null : $(i || e.value.endDate, r || e.value.endTimeValue);
					},
					get isEndFormattedDateValid() {
						return Uo(this.formattedDate, this.endFormattedDate);
					}
				});
			},
			modal: e.modal
		}),
		e.type == "time-range" && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ x("span", { children: " - " }), /* @__PURE__ */ x(Lo, {
			min: e.value.timeValue ? e.value.timeValue.hour * 60 + e.value.timeValue.minute : void 0,
			isInvalid: e.invalidEndTime ?? (!!e.value.endTimeValue && !e.value.isEndFormattedDateValid),
			"aria-label": "End Time Picker",
			locale: e.locale,
			onChange: (t) => {
				let n = Ho(e.value?.date, t);
				e.value.setEndTimeValue(t), e.onChange?.({
					type: "end",
					date: n,
					timeValue: t,
					get formattedDate() {
						return e.value.date === null ? null : $(e.value.date, e.value.timeValue);
					},
					get endFormattedDate() {
						return this.date === null ? null : $(this.date, this.timeValue);
					},
					get isEndFormattedDateValid() {
						return Uo(this.formattedDate, this.endFormattedDate);
					}
				});
			},
			value: e.value?.endTimeValue,
			modal: e.modal
		})] })
	] });
};
function Ho(e, t) {
	return je(e ?? /* @__PURE__ */ new Date(0), {
		hours: t.hour,
		minutes: t.minute
	});
}
function Uo(e, t) {
	return !e || !t ? !1 : Ae(e, t);
}
//#endregion
//#region src/components/ui-composite/DialogOrDrawer.tsx
var Wo = a.createContext(null);
function Go() {
	let e = a.useContext(Wo);
	if (!e) throw Error("DialogOrDrawer components must be used within DialogOrDrawer.Root");
	return e;
}
function Ko(e) {
	let t = Fi(), n = a.useMemo(function() {
		return { isMobile: t };
	}, [t]);
	return /* @__PURE__ */ x(Wo.Provider, {
		value: n,
		children: x(t ? wi : gt, {
			open: e.open,
			onOpenChange: e.onOpenChange,
			children: e.children
		})
	});
}
function qo(e) {
	let { isMobile: t } = Go();
	return x(t ? Ti : _t, {
		asChild: e.asChild,
		children: e.children
	});
}
function Jo(e) {
	let { isMobile: t } = Go(), { showCloseButton: n = !0, children: r, className: i, ...a } = e;
	return t ? /* @__PURE__ */ x(ki, {
		className: i,
		...a,
		children: r
	}) : /* @__PURE__ */ x(xt, {
		className: i,
		showCloseButton: n,
		...a,
		children: r
	});
}
function Yo(e) {
	let { isMobile: t } = Go();
	return x(t ? Di : yt, {
		asChild: e.asChild,
		children: e.children
	});
}
function Xo(e) {
	let { isMobile: t } = Go();
	return x(t ? Ai : St, { ...e });
}
function Zo(e) {
	let { isMobile: t } = Go();
	return x(t ? ji : Ct, { ...e });
}
function Qo(e) {
	let { isMobile: t } = Go();
	return x(t ? Mi : wt, { ...e });
}
function $o(e) {
	let { isMobile: t } = Go();
	return x(t ? Ni : Tt, { ...e });
}
var es = {
	Root: Ko,
	Trigger: qo,
	Content: Jo,
	Close: Yo,
	Header: Xo,
	Footer: Zo,
	Title: Qo,
	Description: $o
};
//#endregion
//#region src/components/ui-composite/icons/SkipIcon.tsx
function ts() {
	return /* @__PURE__ */ x("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "20",
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		viewBox: "0 0 512 440.64",
		children: /* @__PURE__ */ x("path", {
			"fill-rule": "nonzero",
			d: "M175.62 399.21c9.75 2.44 15.69 12.33 13.25 22.08-2.44 9.76-12.33 15.69-22.08 13.25-59.06-14.88-106.52-52.3-135.48-100.77C2.34 285.3-8.14 225.8 6.72 166.78c14.87-59.06 52.3-106.5 100.77-135.47S215.46-8.14 274.48 6.72c20.6 5.19 39.82 13.14 57.33 23.35a219.44 219.44 0 0 1 47.18 36.99l.14-11.58c.13-10.04 8.38-18.07 18.41-17.94 10.03.13 18.06 8.38 17.94 18.4l-.71 58.06c-.02 1.86-.33 3.65-.87 5.33-1.66 9.08-9.99 15.59-19.38 14.8l-57.87-4.65c-10.01-.84-17.43-9.63-16.59-19.63.84-10 9.63-17.42 19.62-16.58l15.28 1.23c-.33-.3-.66-.62-.97-.95-11.78-12.38-25.35-23.21-40.42-31.99-14.61-8.52-30.68-15.17-47.92-19.51-49.36-12.43-99.06-3.7-139.5 20.47-40.44 24.17-71.68 63.78-84.1 113.1-12.43 49.35-3.7 99.06 20.47 139.49 24.17 40.44 63.79 71.68 113.1 84.1zM123.11 288.7l5.32-29.31c11.64 2.91 22.13 4.37 31.43 4.37 9.31 0 16.81-.38 22.51-1.14v-11.53l-17.1-1.52c-15.44-1.39-26.05-5.1-31.81-11.11-5.76-6.01-8.64-14.91-8.64-26.69 0-16.21 3.51-27.34 10.54-33.42 7.02-6.08 18.96-9.12 35.8-9.12 16.85 0 32.03 1.58 45.59 4.75L212 202.33c-11.78-1.9-21.21-2.84-28.3-2.84-7.1 0-13.11.31-18.05.94v11.34l13.68 1.33c16.58 1.65 28.05 5.61 34.38 11.87 6.33 6.27 9.5 14.98 9.5 26.12 0 7.98-1.08 14.72-3.24 20.23-2.15 5.51-4.71 9.69-7.68 12.54-2.99 2.84-7.2 5.03-12.64 6.55-5.44 1.52-10.22 2.43-14.34 2.75-4.11.32-9.59.48-16.43.48-16.46 0-31.72-1.65-45.77-4.94zm153.75-49.57v51.66h-37.99V172.08h37.99v48.43c1.71 0 19.22-44.1 21.27-48.43h41.03l-28.49 58.31 29.44 60.4h-41.03l-21.46-51.66h-.76zm76.07 51.66V172.08h37.98v118.71h-37.98zm121.08-28.69h-26.73v28.69h-35.95V172.08h59.83c27.22 0 40.84 14.62 40.84 43.87 0 16.08-3.55 27.99-10.64 35.71-2.66 2.91-6.34 5.38-11.02 7.41-4.68 2.02-10.13 3.03-16.33 3.03zm-26.73-61.67v33.32h10.78c4.55 0 7.88-.48 9.97-1.42 2.08-.95 3.13-3.14 3.13-6.56v-17.36c0-3.42-1.06-5.61-3.13-6.55-2.09-.94-5.43-1.43-9.97-1.43h-10.78zm-209 203.82c-18.71 1.5-23.29 28.46-4.04 35.46 2.66.81 4.7 1.08 7.52.85 12.97-1.16 26.57-3.61 39.08-7.21 20.42-5.96 16.15-36.68-6.37-35.74-1.23.11-2.46.31-3.63.66-8.66 3.03-23.3 5.15-32.56 5.98zm91.77-35c-6.7 5.02-9.03 13.68-6 21.43 4.52 11.06 18.25 14.97 27.83 7.78 10.62-7.8 20.59-16.91 29.58-26.53 2.87-3.05 4.65-7.3 4.83-11.45.74-17.07-19.88-25.75-31.6-13.34-7.26 7.94-15.98 15.74-24.64 22.11z"
		})
	});
}
//#endregion
//#region src/components/ui-composite/input.tsx
var ns = He.div`absolute top-1/2 transform -translate-y-1/2 text-muted-foreground flex justify-center items-center [&_svg]:w-4 [&_svg]:h-4`, rs = a.forwardRef((e, t) => {
	let { className: n, rightIcon: r, leftIcon: i, ...a } = e, o = /* @__PURE__ */ x(Ii, {
		...a,
		ref: t,
		className: q({
			"pl-9": i,
			"pr-9": r
		}, n)
	});
	return !r && !i ? o : /* @__PURE__ */ S("div", {
		className: "relative w-full h-10",
		children: [
			o,
			i && /* @__PURE__ */ x(ns, {
				className: "left-0 ml-2.5",
				children: /* @__PURE__ */ x(b, { children: i })
			}),
			r && /* @__PURE__ */ x(ns, {
				className: "right-0 mr-2.5",
				children: /* @__PURE__ */ x(b, { children: r })
			})
		]
	});
});
//#endregion
//#region src/components/ui-composite/LinearScale.tsx
function is(e) {
	let t = e.step ?? 1;
	return /* @__PURE__ */ x("div", {
		className: "space-x-2",
		children: Array.from({ length: Math.floor((e.max - e.min) / t) + 1 }, (n, r) => e.min + r * t).map((t) => /* @__PURE__ */ x(ao, {
			className: "rounded-full p-0 h-[40px] w-[40px]",
			variant: e.value === t ? "default" : "outline",
			disabled: e.disabled,
			type: "button",
			onClick: () => e.onChange?.(t),
			children: t
		}, t))
	});
}
//#endregion
//#region src/components/ui-composite/LogoLeftDumbbell.tsx
function as(e) {
	return /* @__PURE__ */ S("svg", {
		width: "46",
		height: "42",
		className: q("w-4 h-4", e.className),
		viewBox: "0 0 46 42",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ x("path", {
			d: "M39.1329 41.9087L17.9603 42L24.8274 0.0913043L46 0L39.1329 41.9087Z",
			fill: "#EB37FF"
		}), /* @__PURE__ */ x("path", {
			d: "M13.5616 34.5907L0 34.65L4.39861 7.40935L17.9603 7.35L13.5616 34.5907Z",
			fill: "#EB37FF"
		})]
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialog.tsx
var os = l(null);
function ss() {
	let e = f(os);
	if (!e) throw Error("ResponsiveDialog compound components must be used within ResponsiveDialog.Root");
	return e;
}
function cs({ open: e = !1, onOpenChange: t = () => {}, onClose: n, children: r, desktopBreakpoint: i, forceMode: o, modal: s }) {
	let c = Fi(), l = a.useMemo(() => o === "popover" ? !1 : o === "drawer" ? !0 : i ? window.innerWidth < i : c, [
		c,
		i,
		o
	]), u = a.useMemo(() => ({
		isMobile: l,
		open: e,
		onOpenChange: t,
		onClose: n
	}), [
		l,
		e,
		t,
		n
	]);
	return /* @__PURE__ */ x(os.Provider, {
		value: u,
		children: l ? /* @__PURE__ */ x(wi, {
			onClose: n,
			open: e,
			onOpenChange: t,
			children: r
		}) : /* @__PURE__ */ x(Z, {
			modal: s,
			open: e,
			onOpenChange: t,
			children: r
		})
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogAnchor.tsx
function ls({ asChild: e, children: t, ...n }) {
	let { isMobile: r } = ss();
	return r ? /* @__PURE__ */ x(b, { children: t }) : /* @__PURE__ */ x(Tn, {
		asChild: e,
		...n,
		children: t
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogClose.tsx
function us({ asChild: e, children: t }) {
	let { isMobile: n } = ss();
	return x(n ? Di : wn, {
		asChild: e,
		children: t
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogContent.tsx
function ds({ className: e, children: t, ...n }) {
	let { isMobile: r } = ss();
	return r ? /* @__PURE__ */ x(ki, {
		className: q("max-h-[96vh]", e),
		...n,
		children: t
	}) : /* @__PURE__ */ x(Q, {
		className: e,
		...n,
		children: t
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogDescription.tsx
var fs = a.forwardRef(({ children: e, ...t }, n) => {
	let { isMobile: r } = ss();
	return r ? /* @__PURE__ */ x(Ni, {
		ref: n,
		...t,
		children: e
	}) : /* @__PURE__ */ x("p", {
		ref: n,
		...t,
		className: "text-sm text-muted-foreground",
		children: e
	});
});
fs.displayName = "ResponsiveDialogDescription";
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogFooter.tsx
function ps({ children: e, ...t }) {
	let { isMobile: n } = ss();
	return x(n ? ji : "div", {
		...t,
		children: e
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogHeader.tsx
function ms({ children: e, ...t }) {
	let { isMobile: n } = ss();
	return x(n ? Ai : "div", {
		...t,
		children: e
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogTitle.tsx
var hs = a.forwardRef(({ children: e, ...t }, n) => {
	let { isMobile: r } = ss();
	return r ? /* @__PURE__ */ x(Mi, {
		ref: n,
		...t,
		children: e
	}) : /* @__PURE__ */ x("h2", {
		ref: n,
		...t,
		className: "text-lg font-semibold leading-none tracking-tight",
		children: e
	});
});
hs.displayName = "ResponsiveDialogTitle";
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/ResponsiveDialogTrigger.tsx
function gs({ asChild: e, children: t }) {
	let { isMobile: n } = ss();
	return x(n ? Ti : Cn, {
		asChild: e,
		children: t
	});
}
//#endregion
//#region src/components/ui-composite/ResponsiveDialog/index.ts
var _s = {
	Root: cs,
	Trigger: gs,
	Anchor: ls,
	Content: ds,
	Header: ms,
	Footer: ps,
	Title: hs,
	Description: fs,
	Close: us
};
//#endregion
//#region src/components/ui-composite/SelectMultipleButton.tsx
function vs(e) {
	let t = e.options.filter((t) => e.value.includes(t.value));
	return /* @__PURE__ */ S(Z, {
		onOpenChange: e.onOpenChange,
		children: [/* @__PURE__ */ x(Cn, {
			asChild: !0,
			children: /* @__PURE__ */ S(ao, {
				variant: "outline",
				className: q("truncate w-[160px] h-8 rounded-[0.5rem] p-0 px-3", e.className),
				children: [/* @__PURE__ */ S("div", {
					className: "flex items-center capitalize",
					children: [/* @__PURE__ */ x(w, { name: "tabler-plus" }), e.text]
				}), /* @__PURE__ */ x("div", {
					className: "space-x-1",
					children: t.map((e) => /* @__PURE__ */ x("span", {
						className: "truncate px-2 py-1 bg-zinc-100 text-zinc-400 rounded-[4px]",
						children: e.label
					}, e.value))
				})]
			})
		}), /* @__PURE__ */ x(Q, {
			className: "w-[160px] p-0 rounded-[6px]",
			children: /* @__PURE__ */ S(Dt, { children: [/* @__PURE__ */ x(kt, {
				className: "p-0 h-10",
				onValueChange: e.onInputChange
			}), e.options.length > 0 ? /* @__PURE__ */ x(At, { children: /* @__PURE__ */ x(Y, { children: e.options.map((t) => /* @__PURE__ */ S(X, {
				className: "rounded-[4px]",
				onSelect: () => {
					e.onSelect && e.onSelect(t.value);
				},
				children: [/* @__PURE__ */ x("div", {
					className: q("mr-2 flex size-4 items-center justify-center rounded-[4px] border border-primary", e.value.includes(t.value) ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
					children: /* @__PURE__ */ x(w, {
						name: "tabler-check",
						className: "size-4 rounded-none rounded-0",
						"aria-hidden": "true"
					})
				}), /* @__PURE__ */ x("span", {
					className: "truncate",
					children: t.label
				})]
			}, t.value)) }) }) : /* @__PURE__ */ S(b, { children: [e.options.length === 0 && !e.isLoading && /* @__PURE__ */ x("div", {
				className: "text-center text-sm p-2",
				children: e.emptyText ?? "No options available"
			}), e.isLoading && /* @__PURE__ */ x("div", {
				className: "w-full flex justify-center p-2",
				children: /* @__PURE__ */ x(w, {
					name: "tabler-loader-2",
					className: "animate-spin text-zinc-400 h-4 w-4"
				})
			})] })] })
		})]
	});
}
//#endregion
//#region src/components/ui-composite/table.tsx
var ys = a.forwardRef((e, t) => /* @__PURE__ */ x(qn, {
	...e,
	ref: t,
	className: q("hover:bg-background", e.className)
}));
//#endregion
//#region src/components/ui-composite/TableGrid.tsx
function bs(e) {
	return /* @__PURE__ */ x("div", {
		className: q("p-2 my-auto", e.className),
		children: e.children
	});
}
function xs(e) {
	return /* @__PURE__ */ x(bs, {
		className: q("text-primary text-opacity-[0.56] font-normal pt-0", e.className),
		children: e.children
	});
}
var Ss = o.createContext(null);
function Cs(e) {
	let t = e.columns.map((e) => typeof e == "string" ? "1fr" : "width" in e ? typeof e.width == "number" ? `${e.width}px` : e.width : "1fr").join(" "), n = e.spacing ?? "sm";
	return /* @__PURE__ */ x(Ss.Provider, {
		value: {
			props: e,
			columnSizes: t
		},
		children: /* @__PURE__ */ S("div", {
			className: q("text-sm", e.className),
			children: [/* @__PURE__ */ x("div", {
				className: q("grid", e.headerClassName),
				style: { gridTemplateColumns: t },
				children: e.columns.map((t, n) => typeof t == "string" ? /* @__PURE__ */ x(xs, {
					className: q(e.columnClassName),
					children: t
				}, t) : /* @__PURE__ */ x(xs, {
					className: q(e.columnClassName, t.className),
					children: t.content
				}, t.key || n))
			}), /* @__PURE__ */ x("div", {
				className: q({
					"space-y-0": n === "none",
					"space-y-2": n === "xs",
					"space-y-4": n === "sm",
					"space-y-8": n === "md",
					"space-y-12": n === "lg"
				}, e.rowsContainerClassName),
				children: e.children
			})]
		})
	});
}
function ws() {
	let e = o.useContext(Ss);
	if (!e) throw Error("useTableGridContext must be used within a TableGrid");
	return e;
}
function Ts(e) {
	let t = ws(), { className: n, isExpanded: r, ...i } = e;
	return /* @__PURE__ */ x("div", {
		className: q("grid border transition-colors rounded-lg hover:bg-muted/50 data-[state=selected]:bg-muted odd:bg-secondary-muted even:bg-background", n),
		style: {
			gridTemplateColumns: t.columnSizes,
			gridTemplateRows: r ? "auto 1fr" : "auto"
		},
		...i,
		children: e.children
	});
}
function Es(e) {
	return /* @__PURE__ */ x(bs, {
		className: q("min-h-[44px] content-center", e.className),
		children: e.children
	});
}
//#endregion
//#region src/components/ui-composite/multi-select.tsx
var Ds = C("m-1 transition-all duration-300 ease-in-out", {
	variants: {
		variant: {
			default: "border-foreground/10 text-foreground bg-card hover:bg-card/80",
			secondary: "border-foreground/10 bg-secondary text-secondary-foreground hover:bg-secondary/80",
			destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
			inverted: "inverted"
		},
		badgeAnimation: {
			bounce: "hover:-translate-y-1 hover:scale-110",
			pulse: "hover:animate-pulse",
			wiggle: "hover:animate-wiggle",
			fade: "hover:opacity-80",
			slide: "hover:translate-x-1",
			none: ""
		}
	},
	defaultVariants: {
		variant: "default",
		badgeAnimation: "bounce"
	}
}), Os = a.forwardRef(({ options: e, onValueChange: t, variant: n, defaultValue: r = [], placeholder: i = "Select options", animation: o = 0, animationConfig: s, maxCount: c = 3, modalPopover: l = !1, className: u, hideSelectAll: d = !1, searchable: f = !0, emptyIndicator: p, autoSize: m = !1, singleLine: h = !1, popoverClassName: g, disabled: _ = !1, responsive: v, minWidth: y, maxWidth: C, deduplicateOptions: ee = !1, resetOnDefaultValueChange: te = !0, closeOnSelect: ne = !1, ...re }, ie) => {
	let [T, E] = a.useState(r), [D, O] = a.useState(!1), [ae, oe] = a.useState(!1), [k, se] = a.useState(""), [A, j] = a.useState(""), [M, ce] = a.useState(""), le = a.useRef(T.length), ue = a.useRef(D), de = a.useRef(k), N = a.useCallback((e, t = "polite") => {
		t === "assertive" ? (ce(e), setTimeout(() => ce(""), 100)) : (j(e), setTimeout(() => j(""), 100));
	}, []), P = a.useId(), F = `${P}-listbox`, I = `${P}-description`, fe = `${P}-count`, pe = a.useRef(r), L = a.useCallback((e) => e.length > 0 && "heading" in e[0], []), R = a.useCallback((e, t) => {
		if (e.length !== t.length) return !1;
		let n = [...e].sort(), r = [...t].sort();
		return n.every((e, t) => e === r[t]);
	}, []), z = a.useCallback(() => {
		E(r), O(!1), se(""), t(r);
	}, [r, t]), B = a.useRef(null);
	a.useImperativeHandle(ie, () => ({
		reset: z,
		getSelectedValues: () => T,
		setSelectedValues: (e) => {
			E(e), t(e);
		},
		clear: () => {
			E([]), t([]);
		},
		focus: () => {
			if (B.current) {
				B.current.focus();
				let e = B.current.style.outline, t = B.current.style.outlineOffset;
				B.current.style.outline = "2px solid var(--ring)", B.current.style.outlineOffset = "2px", setTimeout(() => {
					B.current && (B.current.style.outline = e, B.current.style.outlineOffset = t);
				}, 1e3);
			}
		}
	}), [
		z,
		T,
		t
	]);
	let [V, me] = a.useState("desktop");
	a.useEffect(() => {
		if (typeof window > "u") return;
		let e = () => {
			let e = window.innerWidth;
			me(e < 640 ? "mobile" : e < 1024 ? "tablet" : "desktop");
		};
		return e(), window.addEventListener("resize", e), () => {
			typeof window < "u" && window.removeEventListener("resize", e);
		};
	}, []);
	let H = (() => {
		if (!v) return {
			maxCount: c,
			hideIcons: !1,
			compactMode: !1
		};
		if (v === !0) {
			let e = {
				mobile: {
					maxCount: 2,
					hideIcons: !1,
					compactMode: !0
				},
				tablet: {
					maxCount: 4,
					hideIcons: !1,
					compactMode: !1
				},
				desktop: {
					maxCount: 6,
					hideIcons: !1,
					compactMode: !1
				}
			}[V];
			return {
				maxCount: e?.maxCount ?? c,
				hideIcons: e?.hideIcons ?? !1,
				compactMode: e?.compactMode ?? !1
			};
		}
		let e = v[V];
		return {
			maxCount: e?.maxCount ?? c,
			hideIcons: e?.hideIcons ?? !1,
			compactMode: e?.compactMode ?? !1
		};
	})(), he = () => {
		if (s?.badgeAnimation) switch (s.badgeAnimation) {
			case "bounce": return ae ? "animate-bounce" : "hover:-translate-y-1 hover:scale-110";
			case "pulse": return "hover:animate-pulse";
			case "wiggle": return "hover:animate-wiggle";
			case "fade": return "hover:opacity-80";
			case "slide": return "hover:translate-x-1";
			case "none": return "";
			default: return "";
		}
		return ae ? "animate-bounce" : "";
	}, ge = () => {
		if (s?.popoverAnimation) switch (s.popoverAnimation) {
			case "scale": return "animate-scaleIn";
			case "slide": return "animate-slideInDown";
			case "fade": return "animate-fadeIn";
			case "flip": return "animate-flipIn";
			case "none": return "";
			default: return "";
		}
		return "";
	}, U = a.useCallback(() => {
		if (e.length === 0) return [];
		let t;
		t = L(e) ? e.flatMap((e) => e.options) : e;
		let n = /* @__PURE__ */ new Set(), r = [], i = [];
		return t.forEach((e) => {
			n.has(e.value) ? (r.push(e.value), ee || i.push(e)) : (n.add(e.value), i.push(e));
		}), ee ? i : t;
	}, [
		e,
		ee,
		L
	]), _e = a.useCallback((e) => U().find((t) => t.value === e), [U]), ve = a.useMemo(() => !f || !k ? e : e.length === 0 ? [] : L(e) ? e.map((e) => ({
		...e,
		options: e.options.filter((e) => e.label.toLowerCase().includes(k.toLowerCase()) || e.value.toLowerCase().includes(k.toLowerCase()))
	})).filter((e) => e.options.length > 0) : e.filter((e) => e.label.toLowerCase().includes(k.toLowerCase()) || e.value.toLowerCase().includes(k.toLowerCase())), [
		e,
		k,
		f,
		L
	]), ye = (e) => {
		if (e.key === "Enter") O(!0);
		else if (e.key === "Backspace" && !e.currentTarget.value) {
			let e = [...T];
			e.pop(), E(e), t(e);
		}
	}, be = (e) => {
		if (_ || _e(e)?.disabled) return;
		let n = T.includes(e) ? T.filter((t) => t !== e) : [...T, e];
		E(n), t(n), ne && O(!1);
	}, xe = () => {
		_ || (E([]), t([]));
	}, Se = () => {
		_ || O((e) => !e);
	}, Ce = () => {
		if (_) return;
		let e = T.slice(0, H.maxCount);
		E(e), t(e);
	}, we = () => {
		if (_) return;
		let e = U().filter((e) => !e.disabled);
		if (T.length === e.length) xe();
		else {
			let n = e.map((e) => e.value);
			E(n), t(n);
		}
		ne && O(!1);
	};
	a.useEffect(() => {
		if (!te) return;
		let e = pe.current;
		R(e, r) || (R(T, r) || E(r), pe.current = [...r]);
	}, [
		r,
		T,
		R,
		te
	]);
	let W = {
		minWidth: y || (V === "mobile" ? "0px" : "200px"),
		maxWidth: C || "100%",
		width: m ? "auto" : "100%"
	};
	return a.useEffect(() => {
		D || se("");
	}, [D]), a.useEffect(() => {
		let e = T.length, t = U(), n = t.filter((e) => !e.disabled).length;
		if (e !== le.current) {
			let r = e - le.current;
			if (r > 0) {
				let i = T.slice(-r).map((e) => t.find((t) => t.value === e)?.label).filter(Boolean);
				i.length === 1 ? N(`${i[0]} selected. ${e} of ${n} options selected.`) : N(`${i.length} options selected. ${e} of ${n} total selected.`);
			} else r < 0 && N(`Option removed. ${e} of ${n} options selected.`);
			le.current = e;
		}
		if (D !== ue.current && (N(D ? `Dropdown opened. ${n} options available. Use arrow keys to navigate.` : "Dropdown closed."), ue.current = D), k !== de.current && k !== void 0) {
			if (k && D) {
				let e = t.filter((e) => e.label.toLowerCase().includes(k.toLowerCase()) || e.value.toLowerCase().includes(k.toLowerCase())).length;
				N(`${e} option${e === 1 ? "" : "s"} found for "${k}"`);
			}
			de.current = k;
		}
	}, [
		T,
		D,
		k,
		N,
		U
	]), /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ S("div", {
		className: "sr-only",
		children: [/* @__PURE__ */ x("div", {
			"aria-live": "polite",
			"aria-atomic": "true",
			role: "status",
			children: A
		}), /* @__PURE__ */ x("div", {
			"aria-live": "assertive",
			"aria-atomic": "true",
			role: "alert",
			children: M
		})]
	}), /* @__PURE__ */ S(Z, {
		open: D,
		onOpenChange: O,
		modal: l,
		children: [
			/* @__PURE__ */ x("div", {
				id: I,
				className: "sr-only",
				children: "Multi-select dropdown. Use arrow keys to navigate, Enter to select, and Escape to close."
			}),
			/* @__PURE__ */ x("div", {
				id: fe,
				className: "sr-only",
				"aria-live": "polite",
				children: T.length === 0 ? "No options selected" : `${T.length} option${T.length === 1 ? "" : "s"} selected: ${T.map((e) => _e(e)?.label).filter(Boolean).join(", ")}`
			}),
			/* @__PURE__ */ x(Cn, {
				asChild: !0,
				children: /* @__PURE__ */ x(J, {
					ref: B,
					...re,
					onClick: Se,
					disabled: _,
					role: "combobox",
					"aria-expanded": D,
					"aria-haspopup": "listbox",
					"aria-controls": D ? F : void 0,
					"aria-describedby": `${I} ${fe}`,
					"aria-label": `Multi-select: ${T.length} of ${U().length} options selected. ${i}`,
					className: q("flex p-1 rounded-md border min-h-10 h-auto items-center justify-between bg-inherit hover:bg-inherit [&_svg]:pointer-events-auto", m ? "w-auto" : "w-full", H.compactMode && "min-h-8 text-sm", V === "mobile" && "min-h-12 text-base", _ && "opacity-50 cursor-not-allowed", u),
					style: {
						...W,
						maxWidth: `min(${W.maxWidth}, 100%)`
					},
					children: T.length > 0 ? /* @__PURE__ */ S("div", {
						className: "flex justify-between items-center w-full",
						children: [/* @__PURE__ */ S("div", {
							className: q("flex items-center gap-1", h ? "overflow-x-auto multiselect-singleline-scroll" : "flex-wrap", H.compactMode && "gap-0.5"),
							style: h ? { paddingBottom: "4px" } : {},
							children: [T.slice(0, H.maxCount).map((e) => {
								let t = _e(e), r = t?.icon, i = t?.style;
								if (!t) return null;
								let a = {
									animationDuration: `${o}s`,
									...i?.badgeColor && { backgroundColor: i.badgeColor },
									...i?.gradient && {
										background: i.gradient,
										color: "white"
									}
								};
								return /* @__PURE__ */ S(Xe, {
									className: q(he(), Ds({ variant: n }), i?.gradient && "text-white border-transparent", H.compactMode && "text-xs px-1.5 py-0.5", V === "mobile" && "max-w-[120px] truncate", h && "flex-shrink-0 whitespace-nowrap", "[&>svg]:pointer-events-auto"),
									style: {
										...a,
										animationDuration: `${s?.duration || o}s`,
										animationDelay: `${s?.delay || 0}s`
									},
									children: [
										r && !H.hideIcons && /* @__PURE__ */ x(r, {
											className: q("h-4 w-4 mr-2", H.compactMode && "h-3 w-3 mr-1", i?.iconColor && "text-current"),
											...i?.iconColor && { style: { color: i.iconColor } }
										}),
										/* @__PURE__ */ x("span", {
											className: q(V === "mobile" && "truncate"),
											children: t.label
										}),
										/* @__PURE__ */ x("div", {
											role: "button",
											tabIndex: 0,
											onClick: (t) => {
												t.stopPropagation(), be(e);
											},
											onKeyDown: (t) => {
												(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), be(e));
											},
											"aria-label": `Remove ${t.label} from selection`,
											className: "ml-2 h-4 w-4 cursor-pointer hover:bg-white/20 rounded-sm p-0.5 -m-0.5 focus:outline-none focus:ring-1 focus:ring-white/50",
											children: /* @__PURE__ */ x(w, {
												name: "tabler-circle-x",
												className: q("h-3 w-3", H.compactMode && "h-2.5 w-2.5")
											})
										})
									]
								}, e);
							}).filter(Boolean), T.length > H.maxCount && /* @__PURE__ */ S(Xe, {
								className: q("bg-transparent text-foreground border-foreground/1 hover:bg-transparent", he(), Ds({ variant: n }), H.compactMode && "text-xs px-1.5 py-0.5", h && "flex-shrink-0 whitespace-nowrap", "[&>svg]:pointer-events-auto"),
								style: {
									animationDuration: `${s?.duration || o}s`,
									animationDelay: `${s?.delay || 0}s`
								},
								children: [`+ ${T.length - H.maxCount} more`, /* @__PURE__ */ x(w, {
									name: "tabler-circle-x",
									className: q("ml-2 h-4 w-4 cursor-pointer", H.compactMode && "ml-1 h-3 w-3"),
									onClick: (e) => {
										e.stopPropagation(), Ce();
									}
								})]
							})]
						}), /* @__PURE__ */ S("div", {
							className: "flex items-center justify-between",
							children: [
								/* @__PURE__ */ x("div", {
									role: "button",
									tabIndex: 0,
									onClick: (e) => {
										e.stopPropagation(), xe();
									},
									onKeyDown: (e) => {
										(e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.stopPropagation(), xe());
									},
									"aria-label": `Clear all ${T.length} selected options`,
									className: "flex items-center justify-center h-4 w-4 mx-2 cursor-pointer text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 rounded-sm",
									children: /* @__PURE__ */ x(w, {
										name: "tabler-x",
										className: "h-4 w-4"
									})
								}),
								/* @__PURE__ */ x(Vn, {
									orientation: "vertical",
									className: "flex min-h-6 h-full"
								}),
								/* @__PURE__ */ x(w, {
									name: "tabler-chevron-down",
									className: "h-4 mx-2 cursor-pointer text-muted-foreground",
									"aria-hidden": "true"
								})
							]
						})]
					}) : /* @__PURE__ */ S("div", {
						className: "flex items-center justify-between w-full mx-auto",
						children: [/* @__PURE__ */ x("span", {
							className: "text-sm text-muted-foreground mx-3",
							children: i
						}), /* @__PURE__ */ x(w, {
							name: "tabler-chevron-down",
							className: "h-4 cursor-pointer text-muted-foreground mx-2"
						})]
					})
				})
			}),
			/* @__PURE__ */ x(Q, {
				id: F,
				role: "listbox",
				"aria-multiselectable": "true",
				"aria-label": "Available options",
				className: q("w-auto p-0", ge(), V === "mobile" && "w-[85vw] max-w-[280px]", V === "tablet" && "w-[70vw] max-w-md", V === "desktop" && "min-w-[300px]", g),
				style: {
					animationDuration: `${s?.duration || o}s`,
					animationDelay: `${s?.delay || 0}s`,
					maxWidth: `min(${W.maxWidth}, 85vw)`,
					maxHeight: V === "mobile" ? "70vh" : "60vh",
					touchAction: "manipulation"
				},
				align: "start",
				onEscapeKeyDown: () => O(!1),
				children: /* @__PURE__ */ S(Dt, { children: [
					f && /* @__PURE__ */ x(kt, {
						placeholder: "Search options...",
						onKeyDown: ye,
						value: k,
						onValueChange: se,
						"aria-label": "Search through available options",
						"aria-describedby": `${P}-search-help`
					}),
					f && /* @__PURE__ */ x("div", {
						id: `${P}-search-help`,
						className: "sr-only",
						children: "Type to filter options. Use arrow keys to navigate results."
					}),
					/* @__PURE__ */ S(At, {
						className: q("max-h-[40vh] overflow-y-auto multiselect-scrollbar", V === "mobile" && "max-h-[50vh]", "overscroll-behavior-y-contain"),
						children: [
							/* @__PURE__ */ x(jt, { children: p || "No results found." }),
							" ",
							!d && !k && /* @__PURE__ */ x(Y, { children: /* @__PURE__ */ S(X, {
								onSelect: we,
								role: "option",
								"aria-selected": T.length === U().filter((e) => !e.disabled).length,
								"aria-label": `Select all ${U().length} options`,
								className: "cursor-pointer",
								children: [/* @__PURE__ */ x("div", {
									className: q("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", T.length === U().filter((e) => !e.disabled).length ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
									"aria-hidden": "true",
									children: /* @__PURE__ */ x(w, {
										name: "tabler-check",
										className: "h-4 w-4"
									})
								}), /* @__PURE__ */ S("span", { children: [
									"(Select All",
									U().length > 20 ? ` - ${U().length} options` : "",
									")"
								] })]
							}, "all") }),
							L(ve) ? ve.map((e) => /* @__PURE__ */ x(Y, {
								heading: e.heading,
								children: e.options.map((e) => {
									let t = T.includes(e.value);
									return /* @__PURE__ */ S(X, {
										onSelect: () => be(e.value),
										role: "option",
										"aria-selected": t,
										"aria-disabled": e.disabled,
										"aria-label": `${e.label}${t ? ", selected" : ", not selected"}${e.disabled ? ", disabled" : ""}`,
										className: q("cursor-pointer", e.disabled && "opacity-50 cursor-not-allowed"),
										disabled: e.disabled,
										children: [
											/* @__PURE__ */ x("div", {
												className: q("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", t ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
												"aria-hidden": "true",
												children: /* @__PURE__ */ x(w, {
													name: "tabler-check",
													className: "h-4 w-4"
												})
											}),
											e.icon && /* @__PURE__ */ x(e.icon, {
												className: "mr-2 h-4 w-4 text-muted-foreground",
												"aria-hidden": "true"
											}),
											/* @__PURE__ */ x("span", { children: e.label })
										]
									}, e.value);
								})
							}, e.heading)) : /* @__PURE__ */ x(Y, { children: ve.map((e) => {
								let t = T.includes(e.value);
								return /* @__PURE__ */ S(X, {
									onSelect: () => be(e.value),
									role: "option",
									"aria-selected": t,
									"aria-disabled": e.disabled,
									"aria-label": `${e.label}${t ? ", selected" : ", not selected"}${e.disabled ? ", disabled" : ""}`,
									className: q("cursor-pointer", e.disabled && "opacity-50 cursor-not-allowed"),
									disabled: e.disabled,
									children: [
										/* @__PURE__ */ x("div", {
											className: q("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", t ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible"),
											"aria-hidden": "true",
											children: /* @__PURE__ */ x(w, {
												name: "tabler-check",
												className: "h-4 w-4"
											})
										}),
										e.icon && /* @__PURE__ */ x(e.icon, {
											className: "mr-2 h-4 w-4 text-muted-foreground",
											"aria-hidden": "true"
										}),
										/* @__PURE__ */ x("span", { children: e.label })
									]
								}, e.value);
							}) }),
							/* @__PURE__ */ x(Mt, {}),
							/* @__PURE__ */ x(Y, { children: /* @__PURE__ */ S("div", {
								className: "flex items-center justify-between",
								children: [T.length > 0 && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ x(X, {
									onSelect: xe,
									className: "flex-1 justify-center cursor-pointer",
									children: "Clear"
								}), /* @__PURE__ */ x(Vn, {
									orientation: "vertical",
									className: "flex min-h-6 h-full"
								})] }), /* @__PURE__ */ x(X, {
									onSelect: () => O(!1),
									className: "flex-1 justify-center cursor-pointer max-w-full",
									children: "Close"
								})]
							}) })
						]
					})
				] })
			}),
			o > 0 && T.length > 0 && /* @__PURE__ */ x(w, {
				name: "tabler-wand",
				className: q("cursor-pointer my-2 text-foreground bg-background w-3 h-3", ae ? "" : "text-muted-foreground"),
				onClick: () => oe(!ae)
			})
		]
	})] });
});
Os.displayName = "MultiSelect";
//#endregion
//#region src/components/ui-composite/CollapsibleText.tsx
function ks(e) {
	let t = e.lines ?? 5, n = e.expanded !== void 0, [r, i] = y(!1), a = n ? e.expanded : r, [o, s] = y(!1), c = v(null);
	function l(t) {
		n ? e.onExpandedChange?.(t) : i(t);
	}
	p(() => {
		let e = c.current;
		if (!e || a) return;
		function t() {
			c.current && s(c.current.scrollHeight > c.current.clientHeight);
		}
		t();
		let n = new ResizeObserver(t);
		return n.observe(e), () => {
			n.disconnect();
		};
	}, [e.text, a]);
	let u = !a, d = !e.text, f = u && o && !!e.label;
	return /* @__PURE__ */ S("div", {
		className: q("w-full", { "cursor-pointer hover:bg-accent/50 rounded-md": f }, e.rootClassName),
		onClick: f ? (e) => {
			e.stopPropagation(), l(!0);
		} : void 0,
		children: [
			e.label ? /* @__PURE__ */ S(J, {
				variant: "ghost",
				onFocus: (e) => {
					e.stopPropagation();
				},
				onClick: a && o ? (e) => {
					e.stopPropagation(), l(!1);
				} : void 0,
				className: q("[&&]:p-0 [&&]:m-0", u || !o ? "pointer-events-none hover:bg-transparent" : "cursor-pointer [&&]:px-1.5 [&&]:py-0.5 [&&]:-mx-1.5", e.labelClassName),
				children: [e.label, o ? /* @__PURE__ */ x(w, {
					name: "tabler-chevron-right",
					className: q("size-3 transition-transform", { "rotate-90": a }),
					strokeWidth: 2
				}) : null]
			}) : null,
			/* @__PURE__ */ S("div", {
				className: "relative",
				children: [/* @__PURE__ */ x("div", {
					ref: c,
					className: q("whitespace-pre-wrap", { "overflow-hidden": u }, e.className),
					style: u ? {
						WebkitLineClamp: t,
						display: "-webkit-box",
						WebkitBoxOrient: "vertical"
					} : void 0,
					children: d && e.placeholder ? /* @__PURE__ */ x("span", {
						className: "text-muted-foreground",
						children: e.placeholder
					}) : e.text
				}), u && o ? /* @__PURE__ */ x("div", { className: "absolute bottom-0 left-0 right-0 h-6 bg-gradient-to-t from-background to-transparent pointer-events-none" }) : null]
			}),
			!e.label && o ? /* @__PURE__ */ x("button", {
				type: "button",
				onFocus: (e) => {
					e.stopPropagation();
				},
				onClick: (e) => {
					e.stopPropagation(), l(!a);
				},
				className: "flex w-full items-center justify-center pt-2.5 outline-none",
				children: /* @__PURE__ */ x(w, {
					name: "tabler-chevron-right",
					className: q("size-4 text-muted-foreground transition-transform", { "rotate-90": a }),
					strokeWidth: 1.8
				})
			}) : null
		]
	});
}
//#endregion
//#region src/components/ui-composite/EditableInput.tsx
function As(e) {
	return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");
}
function js(e) {
	let t = e.cloneNode(!0);
	return t.querySelectorAll("br").forEach((e) => {
		e.replaceWith("\n");
	}), t.querySelectorAll("div, p").forEach((e) => {
		e.before("\n"), e.replaceWith(...Array.from(e.childNodes));
	}), (t.textContent ?? "").replace(/^\n/, "");
}
function Ms(e) {
	let t = e.allowEmpty ?? !0, [{ editing: n, initialValue: r }, i] = y({
		editing: !1,
		initialValue: e.value
	}), [a, o] = y(!1), s = v(null);
	p(() => {
		!n && s.current && (e.multiline ? s.current.innerHTML = As(e.value) : s.current.textContent = e.value);
	}, [
		e.value,
		e.multiline,
		n
	]), p(() => {
		if (n && s.current) {
			s.current.focus();
			let e = window.getSelection();
			if (e) {
				let t = document.createRange();
				t.selectNodeContents(s.current), e.removeAllRanges(), e.addRange(t);
			}
		}
	}, [n]);
	function c(t) {
		s.current && (e.multiline ? s.current.innerHTML = As(t) : s.current.textContent = t);
	}
	function l() {
		return s.current ? e.multiline ? js(s.current) : s.current.textContent ?? "" : "";
	}
	function u() {
		!e.disabled && !n && i({
			editing: !0,
			initialValue: e.value
		});
	}
	function d() {
		if (!n) return;
		o(!1);
		let a = l().trim(), s = !t && a.length === 0 ? r : a;
		c(s), i({
			editing: !1,
			initialValue: s
		}), s !== e.value && e.onChange?.(s), s !== r && e.onSubmit?.(s);
	}
	function f() {
		let n = l();
		(t || n.trim().length > 0) && e.onChange?.(n);
	}
	function m(t) {
		t.key === "Enter" && (!e.multiline || !t.shiftKey) && (t.preventDefault(), d()), t.key === "Escape" && (t.preventDefault(), o(!1), c(r), i({
			editing: !1,
			initialValue: r
		}), r !== e.value && e.onChange?.(r));
	}
	function h(e) {
		e.preventDefault();
		let t = e.clipboardData.getData("text/plain"), n = window.getSelection();
		if (!n || n.rangeCount === 0) return;
		let r = n.getRangeAt(0), i = document.createTextNode(t);
		r.deleteContents(), r.insertNode(i), r.setStartAfter(i), r.collapse(!0), n.removeAllRanges(), n.addRange(r), f();
	}
	let g = !e.value, _ = n ? r : e.value, b = e.showEditIcon !== !1 && !e.disabled && !n;
	return e.multiline && !n ? /* @__PURE__ */ x("div", {
		className: "w-full",
		children: /* @__PURE__ */ S("div", {
			className: q("flex items-center", e.showEditIconOnHover && "group/editable"),
			children: [/* @__PURE__ */ x("div", {
				className: q("min-w-0 flex-1", {
					"cursor-pointer rounded-md": !e.disabled,
					"pointer-events-none opacity-50": e.disabled
				}),
				onClick: u,
				onKeyDown: (e) => {
					(e.key === "Enter" || e.key === " ") && (e.preventDefault(), u());
				},
				tabIndex: e.disabled ? void 0 : 0,
				role: "textbox",
				children: /* @__PURE__ */ x(ks, {
					text: e.value,
					lines: 5,
					expanded: a,
					onExpandedChange: o,
					label: e.multilineLabel,
					labelClassName: e.multilineLabelClassName,
					className: q("rounded-md px-2 py-1", { "text-muted-foreground": g }, e.className),
					placeholder: e.placeholder
				})
			}), b && /* @__PURE__ */ x(w, {
				name: "tabler-edit",
				onClick: u,
				className: q("ml-1 size-3.5 shrink-0 cursor-pointer", e.showEditIconOnHover && "opacity-0 group-hover/editable:opacity-100 transition-opacity")
			})]
		})
	}) : /* @__PURE__ */ x("div", {
		className: "w-full",
		children: /* @__PURE__ */ S("div", {
			className: q("flex items-center", e.showEditIconOnHover && "group/editable"),
			children: [/* @__PURE__ */ x("div", {
				ref: s,
				role: "textbox",
				tabIndex: e.disabled ? void 0 : 0,
				contentEditable: n,
				suppressContentEditableWarning: !0,
				onFocus: u,
				onBlur: d,
				onInput: f,
				onKeyDown: m,
				onPaste: h,
				className: q("min-w-0 rounded-md px-2 py-1 outline-none bg-transparent", "empty:before:content-[attr(data-placeholder)] empty:before:text-muted-foreground", {
					"border border-ring ring-ring/50 ring-[3px] shadow-xs cursor-text w-full": n,
					"border border-transparent": !n,
					"hover:bg-accent/50 cursor-pointer": !n && !e.disabled,
					"pointer-events-none opacity-50": e.disabled,
					"text-muted-foreground": g && !n,
					"whitespace-pre-wrap": e.multiline,
					truncate: !e.multiline
				}, e.className),
				"data-placeholder": e.placeholder,
				dangerouslySetInnerHTML: e.multiline ? { __html: As(_) } : void 0,
				children: e.multiline ? void 0 : _
			}), b && /* @__PURE__ */ x(w, {
				name: "tabler-edit",
				onClick: u,
				className: q("ml-1 size-3.5 shrink-0 cursor-pointer", e.showEditIconOnHover && "opacity-0 group-hover/editable:opacity-100 transition-opacity")
			})]
		})
	});
}
//#endregion
//#region src/hooks/use-content-height.ts
function Ns(e, t) {
	let [n, r] = y(null), i = m(() => {
		let t = e.current;
		if (!t) return;
		let n = t.style.transition, i = t.style.height, a = t.style.maxHeight;
		t.style.transition = "none", t.style.maxHeight = "none", t.style.height = "0px";
		let o = t.scrollHeight;
		t.style.height = i, t.style.maxHeight = a, t.getBoundingClientRect(), t.style.transition = n, r(o);
	});
	return g(() => {
		i();
	}, [t]), g(() => {
		let t = e.current;
		if (!t) return;
		let n = t.clientWidth, r = new ResizeObserver(() => {
			let e = t.clientWidth;
			e !== n && (n = e, i());
		});
		return r.observe(t), () => {
			r.disconnect();
		};
	}, [e]), n;
}
//#endregion
//#region src/components/ui-composite/EditableMultilineText.tsx
var Ps = 20, Fs = 2;
function Is(e, t) {
	return e * Ps + t + Fs;
}
function Ls(e) {
	let t = e.collapsedLines ?? 5, n = e.maxLines ?? 12, r = h(), i = v(null), a = v(e.value), [o, s] = y({
		expanded: !1,
		editing: !1
	}), c = Ns(i, e.value), l = e.variant === "textarea" ? 16 : 8, u = c === null ? null : Math.max(1, Math.round((c - l) / Ps)), d = u !== null && u > t, f = o.expanded || o.editing, p = u === null ? null : Math.min(u, f ? n : t), m = f && u !== null && u > n, g = Math.max(1, Math.min(t, e.value.split("\n").length));
	function _() {
		s((e) => ({
			...e,
			expanded: !(e.expanded || e.editing)
		}));
	}
	function b() {
		e.readOnly || (a.current = e.value, s({
			expanded: !0,
			editing: !0
		}));
	}
	function C() {
		i.current && (i.current.scrollTop = 0), s((e) => ({
			...e,
			editing: !1
		}));
	}
	function ee(t) {
		t.key === "Escape" && (t.preventDefault(), t.stopPropagation(), e.onChange(a.current), i.current?.blur());
	}
	function te() {
		e.readOnly && d && !f && s((e) => ({
			...e,
			expanded: !0
		}));
	}
	return /* @__PURE__ */ S("div", {
		className: q("flex w-full flex-col", e.variant === "textarea" ? "gap-2" : "gap-1", e.className),
		children: [/* @__PURE__ */ S("button", {
			type: "button",
			onClick: _,
			"aria-expanded": f,
			"aria-controls": r,
			className: q("flex w-fit items-center gap-1 rounded-sm text-sm font-medium outline-none focus-visible:ring-2 focus-visible:ring-ring", { "pointer-events-none": !d }),
			children: [e.label, d ? /* @__PURE__ */ x(w, {
				name: "tabler-chevron-right",
				className: q("size-3 transition-transform", { "rotate-90": f }),
				strokeWidth: 2
			}) : null]
		}), /* @__PURE__ */ x(ar, {
			ref: i,
			id: r,
			value: e.value,
			rows: g,
			placeholder: e.placeholder,
			readOnly: e.readOnly,
			onChange: (t) => {
				e.onChange(t.target.value);
			},
			onFocus: b,
			onBlur: C,
			onKeyDown: ee,
			onClick: te,
			style: p === null ? { maxHeight: Is(t, l) } : { height: Is(p, l) },
			className: q("field-sizing-fixed resize-none text-sm leading-5", m ? "overflow-y-auto" : "overflow-hidden", { "transition-[height] duration-200": !o.editing }, e.variant === "textarea" ? "min-h-10" : "-mx-2 w-[calc(100%+1rem)] rounded-md border px-2 py-1 text-foreground outline-none placeholder:text-muted-foreground", e.variant !== "textarea" && (o.editing ? "border-ring ring-ring/50 ring-[3px] shadow-xs" : "border-transparent"), {
				"cursor-pointer hover:bg-accent/50": !o.editing && !e.readOnly,
				"[mask-image:linear-gradient(to_bottom,black,black_calc(100%_-_24px),transparent)]": !f && d
			})
		})]
	});
}
//#endregion
//#region src/hooks/use-pagination.ts
function Rs(e) {
	let { pageIndex: t, total: n, pageSize: r, siblingCount: i = 1, boundaryCount: a = 2 } = e, o = Math.ceil(n / r);
	return {
		items: _(() => zs(t, o, i, a), [
			t,
			o,
			i,
			a
		]),
		pageCount: o,
		hasNextPage: t < o - 1,
		hasPrevPage: t > 0,
		goToNextPage: () => Math.min(t + 1, o - 1),
		goToPrevPage: () => Math.max(t - 1, 0)
	};
}
function zs(e, t, n, r) {
	let i = e + 1;
	if (t <= r * 2 + n * 2 + 3) return Bs(1, t);
	let a = Math.max(i - n, 1), o = Math.min(i + n, t), s = a > r + 1, c = o < t - r, l = [];
	if (l.push(...Bs(1, r)), s) l.push({
		type: "ellipsis",
		key: "ellipsis-left"
	});
	else {
		let e = Math.max(r, a - 1);
		e > r && l.push(...Bs(r + 1, e));
	}
	let u = s ? a : Math.max(a, r + 1), d = c ? o : Math.min(o, t - r);
	if (u <= d && l.push(...Bs(u, d)), c) l.push({
		type: "ellipsis",
		key: "ellipsis-right"
	});
	else {
		let e = Math.min(t - r + 1, o + 1);
		e < t - r + 1 && l.push(...Bs(e, t - r));
	}
	return l.push(...Bs(t - r + 1, t)), l;
}
function Bs(e, t) {
	let n = [];
	for (let r = e; r <= t; r++) n.push({
		type: "page",
		page: r
	});
	return n;
}
//#endregion
//#region src/components/ui/pagination.tsx
function Vs({ className: e, ...t }) {
	return /* @__PURE__ */ x("nav", {
		role: "navigation",
		"aria-label": "pagination",
		"data-slot": "pagination",
		className: q("mx-auto flex w-full justify-center", e),
		...t
	});
}
function Hs({ className: e, ...t }) {
	return /* @__PURE__ */ x("ul", {
		"data-slot": "pagination-content",
		className: q("flex flex-row items-center gap-1", e),
		...t
	});
}
function Us({ ...e }) {
	return /* @__PURE__ */ x("li", {
		"data-slot": "pagination-item",
		...e
	});
}
function Ws({ className: e, isActive: t, size: n = "icon", ...r }) {
	return /* @__PURE__ */ x("a", {
		"aria-current": t ? "page" : void 0,
		"data-slot": "pagination-link",
		"data-active": t,
		className: q(Ze({
			variant: t ? "outline" : "ghost",
			size: n
		}), e),
		...r
	});
}
function Gs({ className: e, ...t }) {
	return /* @__PURE__ */ x(Ws, {
		"aria-label": "Go to previous page",
		size: "default",
		className: q("gap-1 px-2.5 sm:pl-2.5", e),
		...t,
		children: /* @__PURE__ */ x(w, { name: "tabler-chevron-left" })
	});
}
function Ks({ className: e, ...t }) {
	return /* @__PURE__ */ x(Ws, {
		"aria-label": "Go to next page",
		size: "default",
		className: q("gap-1 px-2.5 sm:pr-2.5", e),
		...t,
		children: /* @__PURE__ */ x(w, { name: "tabler-chevron-right" })
	});
}
function qs({ className: e, ...t }) {
	return /* @__PURE__ */ S("span", {
		"aria-hidden": !0,
		"data-slot": "pagination-ellipsis",
		className: q("flex size-9 items-center justify-center", e),
		...t,
		children: [/* @__PURE__ */ x(w, {
			name: "tabler-dots",
			className: "size-4"
		}), /* @__PURE__ */ x("span", {
			className: "sr-only",
			children: "More pages"
		})]
	});
}
//#endregion
//#region src/components/ui-composite/pagination.tsx
function Js(e) {
	let t = Rs({
		pageIndex: e.pageIndex,
		total: e.total,
		pageSize: e.pageSize,
		siblingCount: e.siblingCount,
		boundaryCount: e.boundaryCount
	});
	return t.pageCount <= 1 ? null : /* @__PURE__ */ x(Vs, {
		className: e.className,
		children: /* @__PURE__ */ S(Hs, { children: [
			/* @__PURE__ */ x(Us, { children: /* @__PURE__ */ x(Gs, {
				onClick: () => e.onPageChange(t.goToPrevPage()),
				className: q({ "pointer-events-none opacity-50": !t.hasPrevPage })
			}) }),
			t.items.map((t) => t.type === "ellipsis" ? /* @__PURE__ */ x(Us, { children: /* @__PURE__ */ x(qs, {}) }, t.key) : /* @__PURE__ */ x(Us, { children: /* @__PURE__ */ x(Ws, {
				isActive: t.page === e.pageIndex + 1,
				onClick: () => e.onPageChange(t.page - 1),
				children: t.page
			}) }, t.page)),
			/* @__PURE__ */ x(Us, { children: /* @__PURE__ */ x(Ks, {
				onClick: () => e.onPageChange(t.goToNextPage()),
				className: q({ "pointer-events-none opacity-50": !t.hasNextPage })
			}) })
		] })
	});
}
//#endregion
//#region src/lib/utils/shallow-equal.ts
function Ys(e, t) {
	if (e === t || Number.isNaN(e) && Number.isNaN(t)) return !0;
	if (!(e instanceof Object) || !(t instanceof Object)) return !1;
	let n = Object.keys(e), { length: r } = n;
	if (r !== Object.keys(t).length) return !1;
	for (let i = 0; i < r; i += 1) {
		let r = n[i];
		if (!(r in t) || e[r] !== t[r] && !(Number.isNaN(e[r]) && Number.isNaN(t[r]))) return !1;
	}
	return !0;
}
//#endregion
//#region src/hooks/use-shallow-effect.ts
function Xs(e, t) {
	if (!e || !t) return !1;
	if (e === t) return !0;
	if (e.length !== t.length) return !1;
	for (let n = 0; n < e.length; n += 1) if (!Ys(e[n], t[n])) return !1;
	return !0;
}
function Zs(e) {
	let t = v([]), n = v(0);
	return Xs(t.current, e) || (t.current = e, n.current += 1), [n.current];
}
function Qs(e, t) {
	p(e, Zs(t));
}
//#endregion
export { pi as Accordion, gi as AccordionContent, mi as AccordionItem, W as AccordionPrimitive, hi as AccordionTrigger, Ur as Alert, Gr as AlertDescription, jr as AlertDialog, Br as AlertDialogAction, Vr as AlertDialogCancel, Fr as AlertDialogContent, zr as AlertDialogDescription, Lr as AlertDialogFooter, Ir as AlertDialogHeader, Pr as AlertDialogOverlay, Nr as AlertDialogPortal, Rr as AlertDialogTitle, Mr as AlertDialogTrigger, Wr as AlertTitle, Ue as Avatar, Ke as AvatarBadge, Ge as AvatarFallback, qe as AvatarGroup, Je as AvatarGroupCount, We as AvatarImage, Xe as Badge, me as Bar, H as BarChart, _i as Breadcrumb, Ci as BreadcrumbEllipsis, yi as BreadcrumbItem, bi as BreadcrumbLink, vi as BreadcrumbList, xi as BreadcrumbPage, Si as BreadcrumbSeparator, ao as Button, Wa as ButtonGroup, Ka as ButtonGroupSeparator, Ga as ButtonGroupText, $e as Calendar, st as Card, dt as CardContent, ut as CardDescription, ft as CardFooter, ct as CardHeader, lt as CardTitle, nt as Carousel, rt as CarouselContent, it as CarouselItem, ot as CarouselNext, at as CarouselPrevious, he as CartesianGrid, ge as Cell, Xr as ChartContainer, ei as ChartLegend, ti as ChartLegendContent, Zr as ChartStyle, Qr as ChartTooltip, $r as ChartTooltipContent, co as Checkbox, pt as Collapsible, ht as CollapsibleContent, ks as CollapsibleText, mt as CollapsibleTrigger, po as Combobox, Fa as ComboboxChip, Pa as ComboboxChips, Ia as ComboboxChipsInput, ja as ComboboxCollection, Ea as ComboboxContent, uo as ComboboxContext, Ma as ComboboxEmpty, ka as ComboboxGroup, Ta as ComboboxInput, Oa as ComboboxItem, Aa as ComboboxLabel, Da as ComboboxList, xa as ComboboxRoot, Na as ComboboxSeparator, Ca as ComboboxTrigger, Sa as ComboboxValue, Dt as Command, Ot as CommandDialog, jt as CommandEmpty, Y as CommandGroup, kt as CommandInput, X as CommandItem, At as CommandList, Mt as CommandSeparator, Nt as CommandShortcut, U as ComposedChart, Pt as ContextMenu, Wt as ContextMenuCheckboxItem, Ht as ContextMenuContent, It as ContextMenuGroup, Ut as ContextMenuItem, Kt as ContextMenuLabel, Lt as ContextMenuPortal, zt as ContextMenuRadioGroup, Gt as ContextMenuRadioItem, qt as ContextMenuSeparator, Jt as ContextMenuShortcut, Rt as ContextMenuSub, Vt as ContextMenuSubContent, Bt as ContextMenuSubTrigger, Ft as ContextMenuTrigger, _e as Customized, vo as DateRangePicker, Vo as DateTimePicker, mo as DefaultOption, gt as Dialog, yt as DialogClose, xt as DialogContent, Tt as DialogDescription, Ct as DialogFooter, St as DialogHeader, es as DialogOrDrawer, bt as DialogOverlay, vt as DialogPortal, wt as DialogTitle, _t as DialogTrigger, wi as Drawer, Di as DrawerClose, ki as DrawerContent, Ni as DrawerDescription, ji as DrawerFooter, Ai as DrawerHeader, Oi as DrawerOverlay, Ei as DrawerPortal, Mi as DrawerTitle, Ti as DrawerTrigger, Yt as DropdownMenu, on as DropdownMenuCheckboxItem, rn as DropdownMenuContent, Zt as DropdownMenuGroup, an as DropdownMenuItem, cn as DropdownMenuLabel, Qt as DropdownMenuPortal, en as DropdownMenuRadioGroup, sn as DropdownMenuRadioItem, ln as DropdownMenuSeparator, un as DropdownMenuShortcut, $t as DropdownMenuSub, nn as DropdownMenuSubContent, tn as DropdownMenuSubTrigger, Xt as DropdownMenuTrigger, Ms as EditableInput, Ls as EditableMultilineText, pn as Form, bn as FormControl, xn as FormDescription, hn as FormField, vn as FormItem, yn as FormLabel, Sn as FormMessage, rs as Input, pa as InputGroup, ha as InputGroupAddon, _a as InputGroupButton, ya as InputGroupInput, va as InputGroupText, ba as InputGroupTextarea, Xa as Item, no as ItemActions, $a as ItemContent, to as ItemDescription, io as ItemFooter, Ja as ItemGroup, ro as ItemHeader, Qa as ItemMedia, Ya as ItemSeparator, eo as ItemTitle, fn as Label, ve as Legend, ye as Line, be as LineChart, is as LinearScale, as as LogoLeftDumbbell, Os as MultiSelect, ho as MultiSelectComboboxProvider, Ra as NumberField, Va as NumberFieldDecrement, za as NumberFieldGroup, Ha as NumberFieldIncrement, Ba as NumberFieldInput, Js as Pagination, Z as Popover, Tn as PopoverAnchor, wn as PopoverClose, Q as PopoverContent, Cn as PopoverTrigger, En as RadioGroup, Dn as RadioGroupItem, xe as ReferenceArea, Se as ReferenceLine, _s as ResponsiveDialog, On as ScrollArea, kn as ScrollBar, An as Select, Pn as SelectContent, jn as SelectGroup, In as SelectItem, Fn as SelectLabel, vs as SelectMultipleButton, zn as SelectScrollDownButton, Rn as SelectScrollUpButton, Ln as SelectSeparator, Nn as SelectTrigger, Mn as SelectValue, Vn as Separator, ri as Sheet, ai as SheetClose, ci as SheetContent, fi as SheetDescription, ui as SheetFooter, li as SheetHeader, si as SheetOverlay, oi as SheetPortal, di as SheetTitle, ii as SheetTrigger, Wi as Sidebar, Qi as SidebarContent, Xi as SidebarFooter, $i as SidebarGroup, ta as SidebarGroupAction, na as SidebarGroupContent, ea as SidebarGroupLabel, Yi as SidebarHeader, Ji as SidebarInput, qi as SidebarInset, ra as SidebarMenu, sa as SidebarMenuAction, ca as SidebarMenuBadge, oa as SidebarMenuButton, ia as SidebarMenuItem, la as SidebarMenuSkeleton, ua as SidebarMenuSub, fa as SidebarMenuSubButton, da as SidebarMenuSubItem, Ui as SidebarProvider, Ki as SidebarRail, Zi as SidebarSeparator, Gi as SidebarTrigger, go as SingleSelectComboboxProvider, Kr as Skeleton, ts as SkipIcon, Bn as Slider, Hn as Switch, Un as Table, Gn as TableBody, Xn as TableCaption, Yn as TableCell, Kn as TableFooter, Cs as TableGrid, Es as TableGridCell, Ts as TableGridRow, Jn as TableHead, Wn as TableHeader, ys as TableHeaderRow, qn as TableRow, Zn as Tabs, tr as TabsContent, $n as TabsList, i as TabsPrimitive, er as TabsTrigger, ar as Textarea, Lo as TimeField, lr as Toast, ur as ToastAction, dr as ToastClose, pr as ToastDescription, or as ToastProvider, fr as ToastTitle, sr as ToastViewport, Er as Toaster, Or as Tooltip, Ar as TooltipContent, Dr as TooltipProvider, kr as TooltipTrigger, Ce as XAxis, we as YAxis, Ye as badgeVariants, Ua as buttonGroupVariants, q as cn, Et as commandDefaultFilter, $ as formatDateTimeToStoredDate, ir as getTextAreaStyles, zo as getTimeDateInitialValue, br as reducer, Qn as tabsListVariants, wr as toast, He as twx, La as useComboboxAnchor, fo as useComboboxContext, Ns as useContentHeight, Bo as useDateTimePickerState, gn as useFormField, Fi as useIsMobile, Rs as usePagination, Qs as useShallowEffect, Hi as useSidebar, ws as useTableGridContext, Tr as useToast };

//# sourceMappingURL=index.js.map